const indiaCities = {
    country: "india",
    iso_country_code: "ind",
    states: [
        {
            name: "andaman & nicobar islands",
            code: "AN",
            cities: [
                "bakultala",
                "bambooflat",
                "car nicobar",
                "garacharma",
                "hut bay",
                "kamorta",
                "malacca",
                "mayabunder",
                "port blair",
                "prothrapur",
                "rangat",
                "tarasa island",
            ],
        },
        {
            name: "andhra pradesh",
            code: "AP",
            cities: [
                "achanta",
                "adoni",
                "allur",
                "amadalavalasa",
                "amalapuram",
                "anakapalle",
                "anantapalli",
                "anantapur",
                "anaparthy",
                "annavaram",
                "araku",
                "atchutapuram apsez",
                "atmakur",
                "atmakur sri potti sriramulu nellore district",
                "attilli",
                "badampudi",
                "badvel",
                "banaganapalle",
                "bandarulanka",
                "banumukkala",
                "bapatla",
                "bestawaripeta",
                "bethamcherla",
                "bheemunipatnam",
                "bhimadole",
                "bhimavaram",
                "bobbili",
                "bowluvada",
                "bugganipalle",
                "chagallu",
                "chebrole khandrika",
                "chebrolu",
                "chennamukkapalle",
                "chennur",
                "chilakaluripet",
                "chimakurthy",
                "chintalavalasa",
                "chintapalle",
                "chippada pharma sez",
                "chirala",
                "chittoor",
                "chodavaram",
                "cumbum",
                "denduluru",
                "devarapalli",
                "dharmavaram",
                "dhone",
                "dommara nandyala",
                "dondapadu kakathiya cement factory",
                "dondapadu kcp cement factory",
                "dowleswaram",
                "draksharamam",
                "dwaraka tirumala",
                "edlapadu",
                "ekambarakuppam",
                "eluru",
                "gajapathinagaram",
                "gajulamandhyam industrial area",
                "gajularega",
                "ganapavaram",
                "gangapatnam",
                "gavaravaram",
                "giddaluru",
                "golugonda",
                "gooty",
                "gopalapuram",
                "gopavaram",
                "gudilova",
                "gudivada",
                "gudur",
                "gundugolanu",
                "guntakal",
                "guntur",
                "gurzala",
                "hanuman junction",
                "hindupur",
                "hiramandalam",
                "horseley hills",
                "hukumpeta",
                "ibrahimpatnam",
                "ichchapuram",
                "india cement factory chilamakuru",
                "indukurpet",
                "industrial growth centre",
                "thimmanapalem",
                "jaggaiahpet",
                "jammalamadugu",
                "jangareddigudem",
                "jarjapupeta",
                "jaypee cement factory budawada",
                "kadapa",
                "kadiri",
                "kaikaram",
                "kakinada",
                "kakkalapalle",
                "kallur",
                "kallur anantapur district",
                "kaluvaya",
                "kalyandurg",
                "kanapaka",
                "kandukur",
                "kanigiri",
                "kankipadu",
                "kantabamsuguda",
                "kathipudi",
                "kavali",
                "kavali industrial area",
                "kodumur",
                "kodur",
                "koikuntla",
                "komarolu",
                "kondapalle",
                "kota",
                "kotabammal",
                "kothapatnam",
                "kothavalasa",
                "kovurpalle",
                "kovvur",
                "kudithipalem",
                "kuppam",
                "kurnool",
                "macherla",
                "machilipatnam",
                "madanapalle",
                "madhurawada",
                "mandapeta",
                "mangalagiri",
                "mangampeta",
                "mangasamudram",
                "markapur",
                "maruteru",
                "medarametla",
                "medikonduru",
                "meliaputti",
                "moragudi",
                "morampudi",
                "muddanur",
                "mulaguntapadu",
                "mulakuddu",
                "mummidivaram",
                "murakambattu",
                "muttukuru",
                "mydukur",
                "mylavaram",
                "nadim tiruvuru",
                "nagaram",
                "nagari",
                "nagireddipalle",
                "nakkapalle",
                "nallajerla",
                "nandigama",
                "nandyal",
                "narasannapeta",
                "narasapur",
                "narasapuram",
                "narasaraopet",
                "narayanapuram vizianagaram district",
                "narayanavanam",
                "narsipatnam",
                "nayudupeta",
                "nellimarla",
                "nellore",
                "nidadavole",
                "ntpc simhadri",
                "nuzvid",
                "ongole",
                "paderu",
                "palacole",
                "palakonda",
                "palamaner",
                "palasa kasibugga",
                "pamidi",
                "pamur",
                "paravada industrial area",
                "parvathipuram",
                "pathapatnam",
                "payakaraopeta",
                "peda boddepalle",
                "pedana",
                "pedatadepalli",
                "peddapuram",
                "pentapadu",
                "perecherla",
                "phirangipuram",
                "piduguralla",
                "pileru",
                "pippara",
                "pithapuram",
                "podalakur",
                "podili",
                "pondura",
                "ponnekallu",
                "ponnur",
                "porumamilla",
                "prattipadu",
                "proddatur",
                "pulivendula",
                "pulla",
                "punganur",
                "puttaparthi",
                "puttur",
                "rajahmundry",
                "rajam",
                "rajampet",
                "ramabhadrapuram",
                "ramachandrapuram",
                "ramapuram",
                "ramathirtham",
                "ramco cement factory dharmavarappadu",
                "rameswaram",
                "rampachodavaram",
                "rayachoti",
                "rayadurg",
                "razole",
                "repalle",
                "rushikonda apiic",
                "salur samalkot",
                "sanivarapupeta",
                "santhanuthalapadu",
                "satrampadu",
                "sattenapalle",
                "singarayakonda",
                "somandepalle",
                "sompeta",
                "sricity",
                "srikakulam",
                "srikalahasti",
                "sriramnagar",
                "srisailam",
                "srungavarapukota",
                "sulluru",
                "sunnipenta",
                "tada",
                "tadepalle",
                "tadepalligudem",
                "tadpatri",
                "tangellamudi",
                "tanuku",
                "tekkali",
                "tenali",
                "thagarapuvalasa",
                "thatipaka",
                "thullur",
                "thumakunta industrial area",
                "tiruchanur",
                "tirumala",
                "tirupati",
                "tummikapalle",
                "tuni",
                "unguturu",
                "uppada",
                "upper sileru project site camp",
                "uravakonda",
                "vaddeswaram",
                "vavilla",
                "velvadam",
                "venkatachalam industrial area",
                "venkatagiri",
                "veparala",
                "vetapalem",
                "vijayapuri south",
                "vijayawada",
                "vinnamala",
                "vinukonda",
                "visakhapatnam",
                "vissannapet",
                "vizianagaram",
                "vsp township",
                "vuyyuru",
                "yanam",
                "yelamanchili",
                "yemmiganur",
                "yenumalapalle",
                "yernagudem",
                "yerraguntla",
            ],
        },
        {
            name: "arunachal pradesh",
            code: "AR",
            cities: [
                "along",
                "anini",
                "basar",
                "boleng",
                "bomdila",
                "changlang",
                "daporijo",
                "deomali",
                "dirang",
                "hawai",
                "itanagar",
                "jairampur",
                "khonsa",
                "koloriang",
                "longding",
                "miao",
                "naharlagun",
                "namsai",
                "pasighat",
                "roing",
                "rupa",
                "sagalee",
                "seppa",
                "tawang",
                "tezu",
                "yingkiong",
                "yupia",
                "ziro",
            ],
        },
        {
            name: "assam",
            code: "AS",
            cities: [
                "abhayapuri",
                "amguri",
                "anand nagar",
                "asudubi",
                "azara",
                "badarpur",
                "badarpur rly town",
                "bamun sualkuchi",
                "bandardewa iid",
                "bangaon",
                "barpathar",
                "barpeta",
                "barpeta road",
                "basugaon",
                "bcpl township",
                "behiating aidc",
                "belsor",
                "bhomoraguri aidc",
                "bhuragaon",
                "bihpuria",
                "bijni",
                "bilasipara",
                "biswanath chariali",
                "bohari",
                "bokajan",
                "bokakhat",
                "bongaigaon",
                "bongaigaon rpcl township",
                "borgolai gt 11",
                "borpukhuri",
                "chabua",
                "chalantapara pt iv",
                "chandrapur bagicha",
                "changsari",
                "chapakhowa town",
                "chapar",
                "charingia gaon",
                "chekonidhara",
                "dahali",
                "dalgaon",
                "damara patpara",
                "dergaon",
                "dhakuakhana",
                "dharapur",
                "dhekiajuli",
                "dhekorgorha",
                "dhemaji",
                "dhing",
                "dhubri",
                "dibrugarh",
                "digaru gaon",
                "digboi",
                "diphu",
                "dispur",
                "doboka",
                "dokmoka",
                "donkamokam",
                "doom dooma",
                "dudhpatil pt v",
                "dudhpatil pt vi",
                "duliajan",
                "duliajan no 1",
                "durga nagar part-v",
                "garal",
                "gauripur",
                "goalpara",
                "gohpur",
                "golaghat",
                "golokganj",
                "goreswar",
                "gossaigaon",
                "guwahati",
                "haflong",
                "hailakandi",
                "hamren",
                "hindustan paper corporation ltd township panchgram",
                "hojai",
                "howli",
                "howraghat",
                "irongmara",
                "jagiroad",
                "jamunamukh",
                "jhagra pt iii",
                "jonai bazar",
                "jorhat",
                "kakaya",
                "kalaigaon town part",
                "kamalabaria nc",
                "kampur town",
                "kanisail pt i",
                "karimganj",
                "khaira bari",
                "kharijapikon",
                "kharupatia",
                "kochpara",
                "kokrajhar",
                "kumar kaibarta gaon",
                "lakhipur",
                "lakhipur, cachar district",
                "lala",
                "lanka",
                "lido tikok",
                "lido town",
                "lumding",
                "lumding rly colony",
                "mahur",
                "maibong",
                "majgaon",
                "makum",
                "mangaldoi",
                "mankachar",
                "margherita",
                "mariani",
                "marigaon",
                "marowa",
                "moran town",
                "moranhat",
                "mornoi industrial area",
                "mushalpur",
                "nagaon",
                "naharkatiya",
                "nahira",
                "nalbari",
                "namrup",
                "narayanpur",
                "naubaisa gaon",
                "nazira",
                "new bongaigaon railway colony",
                "niz bahjani",
                "niz hajo",
                "niz katigorah pt iii",
                "niz mankata",
                "north guwahati",
                "north lakhimpur",
                "numaligarh refinery township",
                "palasbari",
                "pathsala",
                "pub dhaniram pather",
                "raha",
                "rangapara",
                "rangia",
                "rangia iidc",
                "rani",
                "rupahi town",
                "rupiabathan",
                "salakati",
                "salpara molandubi pt i",
                "sanpara",
                "sapatgram",
                "sarbhog",
                "sarthebari",
                "sarupathar",
                "sarupathar bengali",
                "sepon",
                "sibsagar",
                "silapathar",
                "silchar",
                "sonapur gaon",
                "sonari",
                "sualkuchi",
                "takhlibilar pathar",
                "tangla",
                "tegheria",
                "teok",
                "tezpur",
                "thekashu pt i",
                "thekashu pt ii",
                "tihu",
                "tinsukia",
                "titabor town",
                "udalguri",
                "umrangso",
            ],
        },
        {
            name: "bihar",
            code: "BR",
            cities: [
                "amarpur",
                "anwari",
                "araria",
                "areraj",
                "arrah",
                "arwal",
                "asarganj",
                "aurangabad",
                "bagaha",
                "bahadurganj",
                "bahadurpur",
                "bairgania",
                "bakhri",
                "bakhtiarpur",
                "balia",
                "banka",
                "banmankhi bazar",
                "bara",
                "barahiya",
                "barauli",
                "barauni ioc township",
                "barbigha",
                "barh",
                "baruni",
                "baruni thremal power station township",
                "begusarai",
                "behea",
                "belsand",
                "benipur",
                "bettiah",
                "bhabua",
                "bhagalpur",
                "bhagirathpur",
                "biharsharif",
                "bihta",
                "bihta patna district",
                "bikram",
                "bikramganj",
                "birpur",
                "bodh gaya",
                "buxar",
                "chakia",
                "chanari",
                "chand chaur",
                "chanpatia",
                "chapra",
                "dalsinghsarai",
                "darbhanga",
                "dariapur",
                "daudnagar",
                "dehri",
                "dhaka",
                "dighwara",
                "dumari",
                "dumraon",
                "ekangar sarai",
                "fatwah",
                "forbesganj",
                "gaya",
                "gazipur",
                "ghoghardiha",
                "gogri jamalpur",
                "gopalganj",
                "habibpur",
                "hajipur",
                "hanspura",
                "harnaut",
                "hathua",
                "hilsa",
                "hisua",
                "islampur",
                "jagdishpur",
                "jainagar",
                "jamalpur",
                "jamhaur",
                "jamui",
                "janakpur road",
                "janpur",
                "jehanabad",
                "jhajha",
                "jhanjharpur",
                "jogabani",
                "kahalgaon",
                "kanti",
                "kargahia purab",
                "kasba",
                "kataiya",
                "katihar",
                "kesaria",
                "khagaria",
                "kharagpur",
                "khusrupur",
                "kishanganj",
                "koath",
                "koilwar",
                "kumarbagh",
                "lakhisarai",
                "lalganj",
                "laruara",
                "madhepura",
                "madhuban",
                "madhubani",
                "maharajganj",
                "mahnar bazar",
                "mairwa",
                "makhdumpur",
                "malhipur",
                "maner",
                "manihari",
                "mansur chak",
                "marhaura",
                "masaurhi",
                "mathurapur",
                "mehsi",
                "mirganj",
                "mohiuddinagar",
                "mokameh",
                "motihari",
                "motipur",
                "munger",
                "murliganj",
                "muzaffarpur",
                "nabinagar",
                "narkatiaganj",
                "nasrigagnj",
                "naubatpur",
                "naugachhia",
                "nawada",
                "nirmali",
                "nokha",
                "ntpc barh",
                "obra",
                "padri",
                "pakri dayal",
                "pandual",
                "pareo",
                "paria",
                "patna",
                "piro",
                "puraini",
                "purnia",
                "rafiganj",
                "raghunathpur",
                "rajauli",
                "rajgir",
                "ramgarh",
                "ramnagar",
                "raxaul bazar",
                "revelganj",
                "rosera",
                "saharsa",
                "sahebganj",
                "sahebganj banka district",
                "saidpura",
                "samastipur",
                "saraiya",
                "sasaram",
                "satghara",
                "shahpur",
                "sheikhpura",
                "sheohar",
                "sherghati",
                "silao",
                "singhesar asthan",
                "sitamarhi",
                "siwan",
                "sonepur",
                "sugauli",
                "sultanganj",
                "supaul",
                "teghra",
                "telkap",
                "thakurganj",
                "tikari",
                "tola baliadih",
                "tola chain",
                "tola mansaraut",
                "tola pairamatihana",
                "vaishali",
                "warisaliganj",
            ],
        },
        {
            name: "chandigarh",
            code: "CH",
            cities: ["chandigarh", "mohali", "panchkula"],
        },
        {
            name: "chhattisgarh",
            code: "CG",
            cities: [
                "aamdi",
                "abhanpur",
                "adawal",
                "adbhar",
                "ahiwara",
                "akaltara",
                "ambagarh chowki",
                "ambikapur",
                "antagarh",
                "arang",
                "arjunda",
                "bade bacheli",
                "badla",
                "bagbahara",
                "bagicha",
                "baikunthpur",
                "balod",
                "baloda",
                "baloda bazar",
                "balrampur",
                "banarsi",
                "banki mongra",
                "baramkela",
                "barsur",
                "basna",
                "bastar",
                "bemetra",
                "berla",
                "bhairamgarh",
                "bhakhara",
                "bhanupratappur",
                "bhatapara",
                "bhatgaon",
                "bhilai",
                "bhopalpattanam",
                "bijapur",
                "bilaigarh",
                "bilaspur",
                "bilha",
                "birkoni iidc",
                "bodri",
                "borai csidc",
                "century cement baikunth",
                "champa",
                "chandrapur",
                "charama",
                "chharchha",
                "chhuikhadan",
                "chhura",
                "chhurikala",
                "chhuriya kalan",
                "chikhal kasa",
                "chirmiri",
                "dabhra",
                "dalli rajhara",
                "dantewada",
                "daundi lohara",
                "deori",
                "devkar",
                "dhamdha",
                "dhamtari",
                "dharamjaigarh",
                "dipka",
                "dongargaon",
                "dongargarh",
                "dornapal",
                "doundi",
                "durg",
                "farasgaon",
                "fingeshwar",
                "gandai",
                "gariaband",
                "gaurela",
                "gharghoda",
                "gidam",
                "girwarganj iidc",
                "gobra nawapara",
                "govindapur",
                "gunderdehi",
                "gurur",
                "hatkachora",
                "hirmi",
                "jagdalpur",
                "jaijepur",
                "janjgir",
                "jarhi",
                "jarwe",
                "jashpurnagar",
                "jhagrakhand",
                "kanker",
                "kasdol",
                "katghora",
                "katkona",
                "kawardha",
                "keskal",
                "khairagarh",
                "khamharia",
                "kharod",
                "kharora",
                "kharsia",
                "khongapani",
                "kirandul",
                "kondagaon",
                "koni",
                "konta",
                "korba",
                "kota",
                "kotba",
                "kumhari",
                "kunkuri",
                "kurasia",
                "kurud",
                "kusmi",
                "lafarge cement factory arasmeta",
                "lafarge cement factory sonadhi",
                "lailunga",
                "lakhnapur",
                "lawan",
                "lormi",
                "magarlod",
                "mahasamund",
                "mahendragarh",
                "malhar",
                "mandhar industrial area",
                "mandir hasaud",
                "maro",
                "mehmand",
                "mungeli",
                "nagari",
                "nai ledri",
                "namna kalan",
                "narayanpur",
                "narharpur",
                "nawagarh",
                "nawagarh janjgir - champa district",
                "naya baradwar",
                "new raipur",
                "ntpc sipat",
                "pakhanjur",
                "palari",
                "pali",
                "pandaria",
                "pandatarai",
                "paratappur",
                "parpodi",
                "patan",
                "pathalgaon",
                "patharia",
                "pathariya",
                "pendra",
                "phunderdihari",
                "pipariya",
                "pithora",
                "pusaur",
                "rahaud",
                "raigarh",
                "raipur",
                "rajgamar",
                "rajnandgaon",
                "rajpur",
                "ramanujganj",
                "rani durgavati industrial area anjani",
                "ratanpur",
                "rawan ambuja cement plant",
                "sahaspur lohara",
                "saja",
                "sakari",
                "sakti",
                "saragaon",
                "saraipali",
                "sarangarh",
                "sargaon",
                "sariya",
                "sheorinarayan",
                "silpahari industrial area",
                "simga",
                "sirgitti",
                "sitapur",
                "sukma",
                "surajpur",
                "takhatpur",
                "telgaon",
                "tendua iid",
                "tifra",
                "tilda",
                "tumgaon",
                "tundra",
                "ultratech cement plant rawan",
                "utai",
                "vishrampur",
                "vishrampuri",
                "wadrafnagar",
            ],
        },
        {
            name: "dadra & nagar haveli",
            code: "DH",
            cities: [
                "alok city",
                "amli",
                "dungra",
                "masat industrial area",
                "naroli",
                "silvassa",
                "surangi",
            ],
        },
        {
            name: "Delhi",
            code: "DL",
            cities: ["Delhi"],
        },
        {
            name: "Daman & Diu",
            code: "DD",
            cities: ["Dadhel", "Daman", "Diu", "Ghoghla", "Kachigam"],
        },
        {
            name: "Goa",
            code: "GA",
            cities: [
                "Aldona",
                "Anjuna",
                "Aquem",
                "Arambol",
                "Bambolim",
                "Bandora",
                "Benaulim",
                "Bicholim",
                "Borim",
                "Calangute",
                "Calapor",
                "Canacona",
                "Candola",
                "Candolim",
                "Carapur",
                "Chicalim",
                "Chimbel",
                "Chinchinim",
                "Colva",
                "Colvale",
                "Cumbarjua",
                "Cuncolim",
                "Curchorem",
                "Curti",
                "Curtorim",
                "Davorlim",
                "Guirim",
                "Jua",
                "Mandrem",
                "Mapusa",
                "Marcaim",
                "Margao",
                "Mercurim",
                "Moira",
                "Morjim",
                "Navelim",
                "Nerul",
                "Nuvem",
                "Old Goa",
                "Onda",
                "Orgao",
                "Pale",
                "Panaji",
                "Parcem",
                "Penha De Franca",
                "Pernem",
                "Ponda",
                "Porvorim",
                "Priol",
                "Quepem",
                "Queula",
                "Raia",
                "Reis Magos",
                "Saligao",
                "Sancoale",
                "Sanguem",
                "Sanquelim",
                "Sanvordem",
                "Sao Jose de Areal",
                "Siolim",
                "Usgao",
                "Valpoi",
                "Varca",
                "Vasco Da Gama",
                "Xeldem",
            ],
        },
        {
            name: "Gujarat",
            code: "GJ",
            cities: [
                "Abrama",
                "Adalaj",
                "Adityana",
                "Ahmedabad",
                "Ahwa",
                "Alang",
                "Alikherva",
                "Ambaji",
                "Ambaliyasan",
                "Amboli",
                "Amod",
                "Amreli",
                "Anand",
                "Anandpar",
                "Anandpar Jamnagar District",
                "Andada",
                "Anjar",
                "Anklav",
                "Ankleshwar",
                "Antaliya",
                "Arambhada",
                "Arsodiya",
                "Atul",
                "Baben",
                "Babra",
                "Bagasara",
                "Balasinor",
                "Baliyasan",
                "Bansda",
                "Bantwa",
                "Bardoli",
                "Bareja",
                "Barwala",
                "Bavla",
                "Bayad",
                "Bechar Alias Becharaji",
                "Bedi",
                "Bhabhar",
                "Bhachau",
                "Bhadkodara",
                "Bhagal",
                "Bhagal Valsad District",
                "Bhalpara",
                "Bhanvad",
                "Bharuch",
                "Bhat",
                "Bhavnagar",
                "Bhayavadar",
                "Bhilad",
                "Bhiloda",
                "Bhuj",
                "Bhurivel",
                "Bilimora",
                "Bodeli",
                "Boriavi",
                "Borsad",
                "Botad",
                "Chaklasi",
                "Chalala",
                "Chalthan",
                "Chanasma",
                "Changodar GIDC",
                "Chanod",
                "Chhapi",
                "Chhapra",
                "Chhatral",
                "Chhiri",
                "Chhota Udaipur",
                "Chikhli",
                "Chorwad",
                "Chotila",
                "Dabhoi",
                "Dahej SIR",
                "Dakor",
                "Damnagar",
                "Dediapada",
                "Deesa",
                "Dehari",
                "Dehgam",
                "Deodar",
                "Devgadbaria",
                "Devsar",
                "Dhandhuka",
                "Dhanera",
                "Dharampur",
                "Dhasa Vishi",
                "Dhola",
                "Dholka",
                "Dhoraji",
                "Dhrangadhra",
                "Dhrol",
                "Digvijaygram",
                "Dohad",
                "Dungarpur",
                "Dungarpur Bhavnagar District",
                "Dwarka",
                "Gadhada",
                "Gamdi",
                "Gandevi",
                "Gandhidham",
                "Gandhinagar",
                "Gariadhar",
                "Ghogha",
                "GIDC Antaliya",
                "GIDC Panoli",
                "GIDC Por",
                "GIDC Savli",
                "Godhra",
                "Gondal",
                "GSFC Motikhavdi Sikka INA",
                "GSFC Reliance Complex",
                "GWC Township Kovaya",
                "Hajira",
                "Halol",
                "Halvad",
                "Hansalpur",
                "Harij",
                "Himmatnagar",
                "Ichchhapor",
                "Ichhapor",
                "Idar",
                "Jafrabad",
                "Jalalpore",
                "Jamavala",
                "Jambusar",
                "Jamjodhpur",
                "Jamnagar",
                "Jarod",
                "Jasdan",
                "Jetalsar",
                "Jetpur",
                "Jetpur Navagadh",
                "Jhalod",
                "Joshipura",
                "Junagadh",
                "Kadi",
                "Kadodara",
                "Kakoshi",
                "Kalavad",
                "Kalol",
                "Kalol, Panch Mahals District",
                "Kandla",
                "Kanjari",
                "Kanodar",
                "Kapadvanj",
                "Karamsad",
                "Karjan",
                "Kathlal",
                "Katpar",
                "Kavant",
                "Keshod",
                "Kevadiya",
                "Khambhalia",
                "Khambhat",
                "khapat",
                "Kharach",
                "Kharaghoda",
                "Kheda",
                "Khedbrahma",
                "Kheralu",
                "Kim",
                "Kodinar",
                "Kosamba",
                "Kothria",
                "Kutiyana",
                "Lathi",
                "Lavachha",
                "Lilia",
                "Limbdi",
                "Limkheda",
                "Limla",
                "Lodhikas",
                "Lunawada",
                "Madhapar",
                "Mahesana",
                "Mahudha",
                "Mahuva",
                "Mahuvar",
                "Malanka",
                "Maliya",
                "Malpur",
                "Manavadar",
                "Mandvi",
                "Mandvi Surat District",
                "Mangrol",
                "Mankuva",
                "Mansa",
                "Meghraj",
                "Mehmedabad",
                "Mithapur",
                "Modasa",
                "Modhera",
                "Morbi",
                "Mundra",
                "Nadiad",
                "Nalsarovar",
                "Nandej",
                "Nari",
                "Nasvadi",
                "Nava Bhildi",
                "Navlakhi SIR",
                "Navsari",
                "Ode",
                "Okha Port",
                "Orvad",
                "Paddhari",
                "Padra",
                "Palaj",
                "Palanpur",
                "Palej",
                "Palitana",
                "Panoli INA",
                "Parabada",
                "Pardi",
                "Parnera",
                "Patan",
                "Patdi",
                "Pethapur",
                "Petlad",
                "Porbandar",
                "Prantij",
                "Radhanpur",
                "Rajkot",
                "Rajpipla",
                "Rajula",
                "Ranavav",
                "Ranpur",
                "Rapar",
                "Raval",
                "Ravapara",
                "Sagbara",
                "Salaya",
                "Salvav",
                "Sanand",
                "Sanand GIDC",
                "Sanjan",
                "Sanjeli",
                "Santrampur",
                "Saputara",
                "Sarigam",
                "Sathamba",
                "Savarkundla",
                "Savli",
                "Sayan",
                "Selamba",
                "Shapur",
                "Shapur Rajkot District",
                "Shehera",
                "Sidhpur",
                "Sidsar",
                "Sihor",
                "Sikka",
                "Simar SIR",
                "Sojitra",
                "Somnath",
                "Songadh",
                "Songadh Bhavnagar District",
                "Sukhpar",
                "Surajkaradi",
                "Surat",
                "Surendranagar",
                "Sutrapada",
                "Talaja",
                "Talala",
                "Talod",
                "Tarsadi",
                "Thangadh",
                "Thara",
                "Tharad",
                "Thasra",
                "Ukai",
                "Umbergaon",
                "Umrala",
                "Umreth",
                "Una",
                "Undach",
                "Unjha",
                "Upleta",
                "Vadali",
                "Vadia",
                "Vadnagar",
                "Vadodara",
                "Vaghodia",
                "Valia",
                "Vallabhipur",
                "Valsad",
                "Vanthali",
                "Vapi",
                "Vartej",
                "Vasna",
                "Veraval",
                "Veraval Rajkot District",
                "Vijalpor",
                "Vijapur",
                "Vijaynagar",
                "Vilayat GIDC",
                "Viramgam",
                "Virpur",
                "Virpur Rajkot District",
                "Visavadar",
                "Visnagar",
                "Vyara",
                "Wadhwan",
                "Waghai",
                "Wankaner",
            ],
        },
        {
            name: "Haryana",
            code: "HR",
            cities: [
                "Adampur",
                "Ambala",
                "Asankhurd",
                "Assandh",
                "Ateli",
                "Badh Malak",
                "Badli",
                "Baghola",
                "Bahadurgarh",
                "Barara",
                "Barhi Industrial Area",
                "Barwala",
                "Bawal",
                "Bawani Khera",
                "Beri",
                "Bhakali",
                "Bhiwani",
                "Bhondsi",
                "Bhuran",
                "Bilaspur",
                "Binola Industrial Area",
                "Boh",
                "Buria",
                "Chandi Mandir",
                "Chandimandir Bir Ghaggar",
                "Charkhi Dadri",
                "Cheeka",
                "Chhachhrauli",
                "Dharuhera",
                "Ellenabad",
                "Farakhpur",
                "Faridabad",
                "Farrukhnagar",
                "Fatehabad",
                "Ferozepur Jhirka",
                "Ganaur",
                "Gangwa",
                "Garhi Harsaru",
                "Gharaunda",
                "Gohana",
                "Gurugram",
                "Haileymandi",
                "Hansi",
                "Hassanpur",
                "Hathin",
                "Hisar",
                "Hodal",
                "HSIIDC Dudhola Industrial Area",
                "HSIIDC Manakpur Industrial Area",
                "Indri",
                "Industrial Estate Barwala",
                "Ismailabad",
                "Jakhalmandi",
                "Jhajjar",
                "Jind",
                "Julana",
                "Kabri",
                "Kachrauli",
                "Kaithal",
                "Kakar Majra",
                "Kalanaur",
                "Kalanwali",
                "Kalayat",
                "Kalka",
                "Kanina",
                "Karnal",
                "Kharkhoda",
                "Khori Kalan",
                "Kundli",
                "Kundli Industrial Area",
                "Kurukshetra",
                "Ladrawan",
                "Ladwa",
                "Loharu",
                "Maham",
                "Mahendragarh",
                "Majra",
                "Mandi Dabwali",
                "Manesar",
                "Manethi",
                "Mayyer",
                "Mustafabad",
                "Nagal Chaudhry",
                "Nagina",
                "Naraingarh",
                "Narnaul",
                "Narnaund",
                "Narwana",
                "Nilokheri",
                "Nissing",
                "Nuh",
                "Palwal",
                "Panchkula",
                "Panipat",
                "Panipat Refinery Township",
                "Pataudi",
                "Pehowa",
                "Piala",
                "Pinagwan",
                "Pinjore",
                "Punahana",
                "Pundri",
                "Radaur",
                "Rai Industrial Area",
                "Raipur Rani",
                "Ram Garh",
                "Rania",
                "Ratia",
                "Rewari",
                "Rohtak",
                "Roz Ka Meo Industrial Area",
                "Sadaura",
                "Safidon",
                "Saha",
                "Salamba",
                "Samalkha",
                "Sampla",
                "Sankhol",
                "Shahbad",
                "Sikri Industrial Area",
                "Sirsa",
                "Siwani",
                "Sohna",
                "Sonipat",
                "Sunari Kalan",
                "Taoru",
                "Taraori",
                "Tohana",
                "Tosham",
                "Uchana",
                "Ugra Kheri",
                "Uklanamandi",
                "Uncha Siwana",
                "Yamunanagar",
            ],
        },
        {
            name: "Himachal Pradesh",
            code: "HP",
            cities: [
                "Amb Industrial Area",
                "Arki",
                "Baddi",
                "Baddi Industrial Area",
                "Badhal Industrial Area",
                "Bagbania Industrial Area",
                "Bain Attarian Industrial Area",
                "Bakloh",
                "Banjar",
                "Barotiwala Industrial Area",
                "Bhambla Industrial Area",
                "Bhota",
                "Bhuntar",
                "Bilaspur",
                "Chail",
                "Chamba",
                "Chaupal",
                "Chuari Khas",
                "Dagshai",
                "Dalhousie",
                "Daulatpur",
                "Dera Gopipur",
                "Dharampur Industrial Estate",
                "Dharmsala",
                "Gagret",
                "Gagret Industrial Area",
                "Garnota Industrial Area",
                "Ghumarwin",
                "Golthai Industrial Area",
                "Gondpur Industrial Area",
                "Hamirpur",
                "Hatil Industrial Area",
                "Hill Top Industrial Estate",
                "Indora",
                "Jais Industrial Area",
                "Jawalamukhi",
                "Jhakhri",
                "Jharmajri EPIP Phase 1",
                "Jogindarnagar",
                "Jubbal",
                "Jutogh",
                "Kala Amb Industrial Area",
                "Kangra",
                "Kasauli",
                "Kasol",
                "Keylong",
                "Keylong Industrial Estate",
                "Khajjiar",
                "Kinnaur",
                "Kotkhai",
                "Kullu",
                "Lodhi Majra Industrial Area",
                "Manali",
                "Mandi",
                "Manikaran",
                "Mehatpur",
                "Moginand Industrial Area",
                "Nadaun",
                "Nagri Industrial Area",
                "Nagrota Bagwan",
                "Nahan",
                "Naina Devi",
                "Nalagarh",
                "Narkanda",
                "Nurpur",
                "Palampur",
                "Paonta Sahib",
                "Parel Industrial Estate",
                "Parwanoo",
                "Pragpur",
                "Raja Ka Bagh Industrial Area",
                "Rajgarh",
                "Rampur",
                "Ratti Industrial Area",
                "Rawalsar",
                "Reckong Peo",
                "Renuka",
                "Rohru",
                "Sabathu",
                "Sansarpur Terrace Growth Centre Industrial Area",
                "Santokhgarh",
                "Sarkaghat",
                "Sauli Khad Industrial Area",
                "Seoni",
                "Shamshi Industrial Area",
                "Shimla",
                "Shivnagari Holi Industrial Estate",
                "Shoghi",
                "Shoghi Industrial Area",
                "Solan",
                "Solang",
                "Sundarnagar",
                "Tahliwala Industrial Area",
                "Talai",
                "Theog",
                "Tira Sujanpur",
                "Una",
                "YOI",
            ],
        },
        {
            name: "Jammu & Kashmir",
            code: "JK",
            cities: [
                "Achabal",
                "Akhnoor",
                "Anantnag",
                "Arnia",
                "Arwani",
                "Ashmuji Khalsa",
                "Awantipora",
                "Bandipore",
                "Banihal",
                "Baramula",
                "Bari Brahmana EPIP Industrial Estate",
                "Bashohli",
                "Batote",
                "Beerwah",
                "Bhaderwah",
                "Bijbehara",
                "Billawar",
                "Bishna",
                "Chenani",
                "Choglamsar",
                "Dachigam",
                "Doda",
                "Dras",
                "Duru Verinag",
                "Ganderbal",
                "Gho Manhasan",
                "Gorah Salathian",
                "Gulmarg",
                "Hajan",
                "Handwara",
                "Hanle",
                "Hiranagar",
                "Jammu",
                "Jourian",
                "Kargil",
                "Kathua",
                "Katra",
                "Khan Sahib",
                "Khilanmarg",
                "Khour",
                "Khrew",
                "Kishtwar",
                "Kud",
                "Kukernag",
                "Kulgam",
                "Kunzer",
                "Kupwara",
                "Leh",
                "Magam",
                "Mattan",
                "Mohmmad Pora",
                "Nowgam",
                "Nowshehra",
                "Pahalgam",
                "Parole",
                "Patnitop",
                "Pattan",
                "Pulwama",
                "Punch",
                "Qaimoh",
                "Qazigund",
                "Rajauri",
                "Ramban",
                "Ramgarh",
                "Ramnagar",
                "Ranbirsinghpora",
                "Reasi",
                "Rehambal",
                "Samba",
                "Seer Hamdan",
                "Shangus",
                "Shopian",
                "Soolkoot",
                "Sopore",
                "Srinagar",
                "Sumbal",
                "Sunderbani",
                "Talwara",
                "Thanamandi",
                "Tral",
                "Udhampur",
                "Uri",
                "Vijay Pore",
            ],
        },
        {
            name: "Jharkhand",
            code: "JH",
            cities: [
                "AEC Complex",
                "Akdoni Khurd",
                "Alagdiha",
                "Amlabad",
                "Angarpathar",
                "Ara",
                "Bachra",
                "Baharagora",
                "Baliapur",
                "Baliari",
                "Balkundra",
                "Barajamda",
                "Bardubhi",
                "Barharwa",
                "Barhi",
                "Barkakana",
                "Barki Saraiya",
                "Barora",
                "Barughutu",
                "Barwadih",
                "Basaria",
                "Basukinath",
                "Baua Kalan",
                "Bekobar",
                "Berhait Bazar",
                "Bermo",
                "Bhagatdih",
                "Bhandra",
                "Bhandra Bokaro District",
                "Bhim Kanari",
                "Bhojudih",
                "Bhowrah",
                "Bhuli",
                "Bishnugarh",
                "Bishrampur",
                "Bishrampur Latehar District",
                "Bokaro Steel City",
                "Bokaro Thermal",
                "Bongabar",
                "Borio",
                "Bundu",
                "Bursera",
                "Chaibasa",
                "Chain Pur",
                "Chakradharpur",
                "Chakulia",
                "Chandaur",
                "Chandil",
                "Chandrapura",
                "Chandwa",
                "Charhi",
                "Chatra",
                "Chauparan",
                "Chhatatanr",
                "Chhotaputki",
                "Chiria",
                "Chirkunda",
                "Churi",
                "Daltonganj",
                "Danguwapasi",
                "Dari",
                "Deoghar",
                "Deorikalan",
                "Dhanbad",
                "Dhanwar",
                "Dhaunsar",
                "Domchanch",
                "Dugda",
                "Dumarkunda",
                "Dumka",
                "Egarkunr",
                "Garhwa",
                "Ghagra",
                "Ghatshila",
                "Gidi",
                "Giridih",
                "Gobindpur",
                "Godda",
                "Godhar",
                "Gomoh",
                "Gua",
                "Gumia",
                "Gumla",
                "Haludpukhur",
                "Hariharpur",
                "Harina",
                "Hasir",
                "Hazaribagh",
                "Hesla",
                "Hussainabad",
                "Irba",
                "Isri",
                "Jadugora",
                "Jagannathpur",
                "Jai Nagar",
                "Jamadoba",
                "Jamshedpur",
                "Jamtara",
                "Jangalpur",
                "Jaridih Bazar",
                "Jasidih",
                "Jena",
                "Jharia",
                "Jharia Khas",
                "Jhinghipahari",
                "Jhinkpani",
                "Jhumri Tilaiya",
                "Jorapokhar",
                "Kailudih",
                "Kalikapur",
                "Kandra",
                "Kanke",
                "Karma",
                "Karma Chatra District",
                "Karma Tanr",
                "Karmatanr",
                "Kathhara",
                "Katras",
                "Kedla",
                "Kenduadih",
                "Kharkhari",
                "Kharsawan",
                "Khelari",
                "Khunti",
                "Kiriburu",
                "Kodarma",
                "Kuju",
                "Kumarpur",
                "Kumarpur Sahibganj District",
                "Kurpania",
                "Kustai",
                "Lakarka",
                "Lalpania",
                "Lapanga",
                "Latehar",
                "Lohardaga",
                "Loyabad",
                "Madhuban",
                "Madhupur",
                "Mahagma",
                "Mahesh Mundi",
                "Mahuda",
                "Maithon",
                "Majhion",
                "Makoli",
                "Malkera",
                "Mandu",
                "Manohar Pur",
                "Marar",
                "Marma",
                "Matigara",
                "Mera",
                "Meru",
                "Mihijam",
                "Mugma",
                "Muraidih",
                "Muri",
                "Musabani",
                "Nagri Kalan",
                "Narra",
                "Netarhat",
                "Nirsa",
                "Noamundi",
                "Okni No 2",
                "Orla",
                "Pakaur",
                "Palawa",
                "Panchet",
                "Panrra",
                "Paratdih",
                "Pathardih",
                "Patra",
                "Patratu",
                "Phusro",
                "Pondarkanali",
                "Rajbhita",
                "Rajmahal",
                "Ramgarh Cantonment",
                "Ranchi",
                "Ratu",
                "Rehla",
                "Religara",
                "Rohraband",
                "Sahibganj",
                "Sahnidih",
                "Sanri",
                "Saraidhela",
                "Saram",
                "Sarauni",
                "Satgawan",
                "Saunda",
                "Seraikela",
                "Sewai",
                "Shahpur",
                "Sijhua",
                "Sijua",
                "Simdega",
                "Sindri",
                "Sinduria",
                "Sini",
                "Sirka",
                "Siuliban",
                "Suranga",
                "Tapin",
                "Tati",
                "Telo",
                "Telodih",
                "Tenu",
                "Tin Pahar",
                "Tisra",
                "Topa",
                "Topchanchi",
                "Torpa",
                "Toto",
                "Tundiul",
                "Urimari",
            ],
        },
        {
            name: "Karnataka",
            code: "KA",
            cities: [
                "Addur",
                "Adityapatna",
                "Adyar",
                "Afzalpur",
                "Agumbe",
                "Aland",
                "Alevoor",
                "Allipura",
                "Alnavar",
                "Alur",
                "Amaravathi",
                "Ambikanagara",
                "Amble Industrial Area",
                "Aminagad",
                "Ankola",
                "Annigeri",
                "Arasinakunte",
                "Arkalgud",
                "Arkula",
                "Arsikere",
                "Athni",
                "Aurad",
                "Aversa",
                "Bada",
                "Badagaulipady",
                "Badami",
                "Bagalkot",
                "Bagepalli",
                "Bail Hongal",
                "Bandipur",
                "Bangarapet",
                "Bangarpet Industrial Area",
                "Bankapura",
                "Bannur",
                "Bantval",
                "Basavakalyan",
                "Basavana Bagevadi",
                "Belgaum",
                "Bellary",
                "Beltangadi",
                "Belur",
                "Belur Industrial Area",
                "Benakanahalli",
                "Bengaluru",
                "Bethamangala",
                "Bhadravati",
                "Bhalki",
                "Bhatkal",
                "Bhimarayanagudi",
                "Bidadi",
                "Bidadi Industrial Area",
                "Bidar",
                "Bijapur",
                "Bilgi",
                "Birur",
                "Bobruwada",
                "Byadgi",
                "Challakere",
                "Chamarajanagar",
                "Channagiri",
                "Channapatna",
                "Channarayapatna",
                "Chelur",
                "Chik Ballapur",
                "Chikballapur Industrial Area",
                "Chikkajajur",
                "Chikmagalur",
                "Chiknayakanhalli",
                "Chikodi",
                "Chincholi",
                "Chintamani",
                "Chitapur",
                "Chitgoppa",
                "Chitradurga",
                "Dandeli",
                "Dargajogihalli",
                "Davanagere",
                "Devadurga",
                "Devanahalli",
                "Dharwad",
                "Dobaspet Industrial Area",
                "Dod Ballapur Doddaballapur Industrial Area",
                "Doddaballapura Apparel Park",
                "Donimalai Township",
                "Elwala",
                "Gadag Betigeri",
                "Gajendragarh",
                "Gangawati",
                "Ganjimutt",
                "Gargeswari",
                "Gauribidanur",
                "Gejjalagere Industrial Area",
                "Gogipeth",
                "Gokak",
                "Gokak Falls",
                "Gonikoppal",
                "Gubbi",
                "Gudibanda",
                "Gudur",
                "Gulbarga",
                "Guledgudda",
                "Gundlupet",
                "Gurmatkal",
                "Halga",
                "Haliyal",
                "Hampi",
                "Hangal",
                "Hanur",
                "Haralahalli",
                "Haralapura",
                "Harapanahalli",
                "Harihar",
                "Harohalli Industrial Area",
                "Hassan",
                "Hatti",
                "Hatti Gold Mines",
                "Haveri",
                "HD Kote",
                "Heroor",
                "Hirehally Industrial Area",
                "Hirekerur",
                "Hiriyur",
                "Holalkere",
                "Hole Narsipur",
                "Homnabad",
                "Honaga Industrial Area",
                "Honavar",
                "Honnali",
                "Hoovina Hadagalli",
                "Hosanagara",
                "Hosdurga",
                "Hoskote",
                "Hoskote Industrial Area",
                "Hospet",
                "Hubli",
                "Hukeri",
                "Huliyar",
                "Humnabad Industrial Area",
                "Hungund",
                "Hunsur",
                "Ilkal",
                "Indi",
                "Jagalur",
                "Jamkhandi",
                "Jevargi",
                "Jog Falls",
                "JSW Steel Plant",
                "Kadakola",
                "Kadur",
                "Kadwad",
                "Kairangala",
                "Kakati Industrial Area",
                "Kalghatgi",
                "Kamalapuram",
                "Kamalnagar",
                "Kamatgi",
                "Kampli",
                "Kanakapura",
                "Kariyangala",
                "Karkal",
                "Karwar",
                "Kemmannugundi",
                "Kerur",
                "Khanapur",
                "Khangaon",
                "Kodiyal",
                "Kolambe",
                "Kolar",
                "Kollegal",
                "Kollur",
                "Konnur",
                "Koppa",
                "Koppal",
                "Koratagere",
                "Koteshwar",
                "Kotturu",
                "Krishnaraja Sagara",
                "Krishnarajanagara",
                "Krishnarajpet",
                "Kudchi",
                "Kudligi",
                "Kudremukh",
                "Kudur",
                "Kumta",
                "Kundapura",
                "Kundgol",
                "Kunigal",
                "Kunigal Industrial Area",
                "Kurekuppa",
                "Kurgunta",
                "Kushalanagara",
                "Kushtagi",
                "Kuvettu",
                "Lakshmeshwar",
                "Lingsugur",
                "Londa",
                "Machche",
                "Maddur",
                "Madhugiri",
                "Madikeri",
                "Magadi",
                "Mahalingpur",
                "Malavalli",
                "Mallar",
                "Malur",
                "Malur Industrial Area",
                "Mandya",
                "Mandya Industrial Area",
                "Mangalore",
                "Manipura",
                "Manjanady",
                "Manjunath Township Basavkalyan",
                "Manvi",
                "Manvi Industrial Area",
                "Mellahalli",
                "Molakalmuru",
                "Moodabettu",
                "Mouje Nandgad",
                "Mudalgi",
                "Mudbidri",
                "Muddebihal",
                "Mudgal",
                "Mudhol",
                "Mudigere",
                "Muduperar",
                "Mulbagal",
                "Mulgund",
                "Mulki",
                "Mulur",
                "Mundargi",
                "Mundargi Industrial Area",
                "Mundgod",
                "Munirabad Project Area",
                "Munnuru",
                "Mutga",
                "Mutga Gulbarga District",
                "Mysore",
                "Nadsal",
                "Nagamangala",
                "Nandi",
                "Nandur Kesartigi Industrial Area",
                "Nanjangud",
                "Narasapura Industrial Area",
                "Narasimharajapura",
                "Naregal",
                "Nargund",
                "Narikombu",
                "Navalgund",
                "Navoor",
                "Nelamangala",
                "Nipani",
                "Pandavapura",
                "Pattadakal",
                "Pavagada",
                "Periyapatna",
                "Pudu",
                "Puttur",
                "Rabkavi-Banhatti",
                "Raichur",
                "Raichur Growth Centre Industrial Area",
                "Ramanagara",
                "Ramdurg",
                "Ranebennur",
                "Raybag",
                "Robertsonpet",
                "Ron",
                "Sadalgi",
                "Sagagur",
                "Sagar",
                "Sajipanadu",
                "Sakleshpur",
                "Saligram",
                "Sambra",
                "Sandur",
                "Sankeshwar",
                "Sanoor",
                "Sathyamangala",
                "Sattur",
                "Saundatti-Yellamma",
                "Savanur",
                "Sedam",
                "Shahabad",
                "Shahabad ACC",
                "Shahpur",
                "Shaktinagar",
                "Shiggaon",
                "Shikarpur",
                "Shimoga",
                "Shirawad Industrial Area",
                "Shirhatti",
                "Shorapur",
                "Shravanabelgola",
                "Siddapur",
                "Sidlaghatta",
                "Sindgi",
                "Sindhnur",
                "Sira",
                "Siralkoppa",
                "Sirsi",
                "Siruguppa",
                "Solebhavi",
                "Somanahalli Industrial Area",
                "Somvarpet",
                "Sorab",
                "Sringeri",
                "Srinivaspur",
                "Srirampura",
                "Srirangapatna",
                "Sulya",
                "T Narsipura",
                "Talikota",
                "Talipady",
                "Tarikere",
                "Tattilli",
                "Tekkalakote",
                "Terdal",
                "Thandya Industrial Estate",
                "Thimmenahalli Industrial Area",
                "Thumbe",
                "Tiptur",
                "Tirthahalli",
                "Tumkur",
                "Turuvekere",
                "Udupi",
                "Ullal",
                "Uppinangady",
                "Vaddu",
                "Varamballi",
                "Vasantha Narasapura Industrial Area",
                "Venkatapura",
                "Vijayapura",
                "Virajpete",
                "Vittal",
                "Wadi",
                "Yadgir",
                "Yelandur",
                "Yelbarga",
                "Yellapur",
                "Yellur",
            ],
        },
        {
            name: "Kerala",
            code: "KL",
            cities: [
                "Abdu Rahiman Nagar",
                "Adat",
                "Adichanalloor",
                "Adinad",
                "Adoor",
                "Aimanam",
                "Ajanur",
                "Akathiyoor",
                "Ala",
                "Alamcode",
                "Alamcode Thiruvananthapuram District",
                "Alappuzha",
                "Alathur",
                "Alur",
                "Aluva",
                "Amballur",
                "Ancharakandy",
                "Angadipuram",
                "Angamaly",
                "Anthicad",
                "Ariyallur",
                "Arookutty",
                "Aroor",
                "Athirampuzha",
                "Athiyannur",
                "Atholi",
                "Attingal",
                "Avanur",
                "Avinissery",
                "Avittathur",
                "Ayancheri",
                "Ayanivelikulangara",
                "Azhikode",
                "Azhiyur",
                "Azhoor",
                "Balusseri",
                "Bangramanjeshwar",
                "Beypore",
                "Bharanikkavu",
                "Brahmakulam",
                "Chala",
                "Chalakudy",
                "Changanacherry",
                "Chavakkad",
                "Chavara",
                "Chekkiad",
                "Chelakkara",
                "Chelannur",
                "Cheleri",
                "Chelora",
                "Chemancheri",
                "Chendamangalam",
                "Chendrappini",
                "Chengala",
                "Chengamanad",
                "Chengannur",
                "Chennithala",
                "Cheppad",
                "Cheranallur",
                "Cheriyamundam",
                "Cherthala",
                "Cherukavu",
                "Cheruthazham",
                "Cheruthuruthi",
                "Chevvoor",
                "Chingoli",
                "Chirakkal",
                "Chiramanangad",
                "Chiranellur",
                "Chittanda",
                "Chittur-Thathamangalam",
                "Chockli",
                "Choolissery",
                "Choondal",
                "Choornikkara",
                "Chowwara",
                "Desamangalam",
                "Dharmadom",
                "Edacheri",
                "Edakkode",
                "Edappal",
                "Edathala",
                "Edathirinji",
                "Edathiruthy",
                "Edavilangu",
                "Elampalloor",
                "Elayavoor",
                "Eloor",
                "Enkakkad",
                "Eramala",
                "Eramalloor",
                "Eranellur",
                "Eranholi",
                "Erattupetta",
                "Eravattur",
                "Eravu",
                "Ernakulam",
                "Eruvatti",
                "Ettumanoor",
                "Eyyal",
                "Feroke",
                "Guruvayur",
                "Haripad",
                "Hosabettu",
                "Idukki Township",
                "Irikkur",
                "Irimbiliyam",
                "Iringal",
                "Iringaprom",
                "Irinjalakuda",
                "Iriveri",
                "Iroopara",
                "Kadachira",
                "Kadamakkudy",
                "Kadannappalli",
                "Kadavallur",
                "Kadikkad",
                "Kadirur",
                "Kadungalloor",
                "Kaipamangalam",
                "Kalady",
                "Kalady Ernakulam District",
                "Kalamassery",
                "Kallelibhagom",
                "Kallettumkara",
                "Kalliasseri",
                "Kalliyoor",
                "Kallur- Thekkummuri",
                "Kalpetta",
                "Kandamkunnu",
                "Kandanassery",
                "Kanhangad",
                "Kanhirode",
                "Kaniyarkode",
                "Kanjikkuzhi",
                "Kanjikode Industrial Area",
                "Kanjiramkulam",
                "Kannadiparamba",
                "Kannamangalam",
                "Kannamangalam Alappuzha District",
                "Kannapuram",
                "Kannur",
                "Karamuck",
                "Karikkad",
                "Karivellur",
                "Kariyannur",
                "Karthikappally",
                "Karunagappally",
                "Karuvanthuruthy",
                "Kasaragod",
                "Kattakampal",
                "Kattanam",
                "Kattappana",
                "Kattipparuthi",
                "Kattur",
                "Kayamkulam",
                "Keekan",
                "Keerikkad",
                "Keezhallur",
                "Keezhariyur",
                "Kinfra Small Industries Park",
                "Kizhakkummuri",
                "Kizhuparamba",
                "Kizhuppillikkara",
                "Kizhuvalam -Koonthalloor",
                "Kochi",
                "Kodungallur",
                "Kodur",
                "Koipady",
                "Kolacherry",
                "Kolavelloor",
                "Kolazhy",
                "Kollam",
                "Komalapuram",
                "Kondotty",
                "Koodali",
                "Koothali",
                "Koothuparamba",
                "Koottilangadi",
                "Koratty",
                "Kothamangalam",
                "Kottakal",
                "Kottamkara",
                "Kottappally",
                "Kottappuram",
                "Kottarakkara",
                "Kottayam",
                "Kottayam-Malabar",
                "Kottuvally",
                "Kovalam",
                "Kozhenchery",
                "Kozhikode",
                "Kozhukkallur",
                "Kozhukkully",
                "Krishnapuram",
                "Kudlu",
                "Kulasekharapuram",
                "Kulathummal",
                "Kumarakom",
                "Kumaranellur",
                "Kumarapuram",
                "Kumbalangy",
                "Kumily",
                "Kunjathur",
                "Kunnamkulam",
                "Kunnathunad",
                "Kunnummal",
                "Kurattissery",
                "Kureekkad",
                "Kurumathur",
                "Kurumpilavu",
                "Kuruvattur",
                "Kuthiathode",
                "Kuttiattoor",
                "Kuttippuram",
                "Madhur",
                "Malappuram",
                "Manakkody",
                "Manakunnam",
                "Manalur",
                "Manantheri",
                "Manavalassery",
                "Mangalpady",
                "Mangattidam",
                "Maniyat",
                "Maniyoor",
                "Maniyur",
                "Manjeri",
                "Manjeshwar",
                "Mannanchery",
                "Mannar",
                "Mannarkad-I",
                "Marampilly",
                "Marancheri",
                "Marathakkara",
                "Mattannur",
                "Mavelikkara",
                "Mavilayi",
                "Mavoor",
                "Mayyanad",
                "Mayyil",
                "Meenad",
                "Menhaniam",
                "Meppayyur",
                "Mokeri",
                "Moonniyur",
                "Muhamma",
                "Mulamthuruthy",
                "Mulavukad",
                "Mullassery",
                "Mundathikode",
                "Munderi",
                "Munnar",
                "Muthukulam",
                "Muthuthala",
                "Muvattupuzha",
                "Muzhappilangad",
                "Nadapuram",
                "Nadathara",
                "Naduvannur",
                "Naduvattom",
                "Nanmanda",
                "Nannambra",
                "Narath",
                "Nattakam",
                "Nedumangad",
                "Nedumpana",
                "Nedumpura",
                "Neduva",
                "Nelluwaya",
                "Nenmenikkara",
                "New Mahe",
                "Neyyattinkara",
                "Nilambur",
                "Njarackal",
                "North -Thrikkaripur",
                "Oachira",
                "Olavanna",
                "Ongallur- I",
                "Ongallur- II",
                "Othukkungal",
                "Ottappalam",
                "Padiyam",
                "Padiyur",
                "Paduvilayi",
                "Palai",
                "Palakkad",
                "Palayad",
                "Palissery",
                "Pallichal",
                "Pallikkal",
                "Pallikkara",
                "Pallikkunnu",
                "Pallippuram",
                "Pallippuram Thiruvananthapuram District",
                "Pallippuram Thrissur District",
                "Paluvai",
                "Panachikkad",
                "Panangad",
                "Panangad Kozhikode District",
                "Panayam",
                "Panmana",
                "Panniyannur",
                "Panoor",
                "Pantheeramkavu",
                "Pappinisseri",
                "Pappinivattom",
                "Parakkad",
                "Parappukkara",
                "Parappur",
                "Parassala",
                "Parasuvaikkal",
                "Paravoor",
                "Paravur",
                "Pariyaram",
                "Pathanamthitta",
                "Pathirappally",
                "Pathiriyad",
                "Pathiyoor",
                "Pattiom",
                "Pavaratty",
                "Payyannur",
                "Pazhanji",
                "Peermade",
                "Perakam",
                "Peralasseri",
                "Perinad",
                "Peringathur",
                "Perinjanam",
                "Perinthalmanna",
                "Perole",
                "Perumanna",
                "Perumbaikad",
                "Perumbavoor",
                "Peruvallur",
                "Pilicode",
                "Pinarayi",
                "Ponmundam",
                "Ponnani",
                "Poomangalam",
                "Poothakkulam",
                "Porathissery",
                "Pottore",
                "Pudussery Central",
                "Pudussery West",
                "Pullur",
                "Punalur",
                "Punnayur",
                "Punnayurkulam",
                "Puranattukara",
                "Puthencruz",
                "Puthukkad",
                "Puthunagaram",
                "Puthuppally",
                "Puthur",
                "Puzhathi",
                "Quilandy",
                "Ramanattukara",
                "Shiriya",
                "Shoranur",
                "South - Thrikkaripur",
                "Talakkad",
                "Talikkulam",
                "Taliparamba",
                "Tanalur",
                "Thaikattussery",
                "Thaikkad",
                "Thalakkulathur",
                "Thalassery",
                "Thangalur",
                "Thanniyam",
                "Thazhakara",
                "Thazhecode",
                "Thazhuthala",
                "Thekkumkara",
                "Thennala",
                "Thikkody",
                "Thirumittacode-II",
                "Thirunavaya",
                "Thiruvalla",
                "Thiruvananthapuram",
                "Thiruvankulam",
                "Thodiyoor",
                "Thodupuzha",
                "Thottada",
                "Thrikkadavoor",
                "Thrikkaruva",
                "Thrikkovilvattom",
                "Thrippunithura",
                "Thrissur",
                "Thrithala",
                "Thuneri",
                "Thurayur",
                "Tirur",
                "Tirurangadi",
                "Trikkur",
                "Triprangode",
                "Udma",
                "Uliyazhathura",
                "Ulliyeri",
                "Uppala",
                "Urakam",
                "Vadakara",
                "Vadakkekad",
                "Vadakkumkara",
                "Vadakkummuri",
                "Vadakkumthala",
                "Vadama",
                "Vadanappally",
                "Vaikom",
                "Vakkom",
                "Valapattanam",
                "Valayam",
                "Vallachira",
                "Vandiperiyar",
                "Vaniyamkulam-II",
                "Varam",
                "Varappuzha",
                "Varkala",
                "Vattappara",
                "Vayalar",
                "Vazhakkala",
                "Vazhakulam",
                "Vazhayur",
                "Veiloor",
                "Vellanikkara",
                "Velur",
                "Veluthur",
                "Venganoor",
                "Vengara",
                "Vengola",
                "Venkitangu",
                "Venmanad",
                "Vilappil",
                "Villiappally",
                "Vylathur",
                "Vythiri",
                "Wadakkanchery",
            ],
        },
        {
            name: "Lakshadweep",
            code: "LD",
            cities: ["Agatti", "Amini", "Kavaratti", "Minicoy"],
        },
        {
            name: "Madhya Pradesh",
            code: "MP",
            cities: [
                "Agar",
                "Ahirkhedi",
                "Ahirkhedi, Indore District",
                "Ajaygarh",
                "Akoda",
                "Akodia",
                "Alampur",
                "Alirajpur",
                "Alot",
                "Amanganj",
                "Amarkantak",
                "Amarpatan",
                "Amarwara",
                "Ambada",
                "Ambah",
                "Amkhera",
                "Amla",
                "Amlai",
                "Anjad",
                "Antari",
                "Anuppur",
                "Aron",
                "Ashoknagar",
                "Ashta",
                "Athner",
                "Babai",
                "Bada-Malhera",
                "Badarwas",
                "Badi",
                "Badkuhi",
                "Badnagar",
                "Badnawar",
                "Badod",
                "Badoni",
                "Badra",
                "Bagh",
                "Bagli",
                "Baihar",
                "Baikunthpur",
                "Balaghat",
                "Baldeogarh",
                "Bamhani",
                "Bamor",
                "Bamor Morena",
                "Bamora",
                "Banda",
                "Bandhawagarh",
                "Bangarda Bada",
                "Bangawan",
                "Bank",
                "Bansatar Kheda",
                "Baragaon",
                "Baragaon Shajapur",
                "Barauda",
                "Barela",
                "Bareli",
                "Barghat",
                "Bargi",
                "Barhi",
                "Barigarh",
                "Barman Kalan",
                "Baroda",
                "Barwaha",
                "Barwaha Kasba",
                "Barwani",
                "Basoda",
                "Begamganj",
                "Beohari",
                "Berasia",
                "Betma",
                "Betul",
                "Betul Bazar",
                "Bhainsa",
                "Bhainsdehi",
                "Bhander",
                "Bhanpura",
                "Bharveli",
                "Bhavra",
                "Bhedaghat",
                "Bhicholi Hapsi",
                "Bhikangaon",
                "Bhilakhedi",
                "Bhind",
                "Bhitarwar",
                "Bhonrasa",
                "Bhopal",
                "Biaora",
                "Bichhiya",
                "Bichhiya Vidisha District",
                "Bijawar",
                "Bijuri",
                "Bilaua",
                "Bina",
                "Birsinghpur",
                "Boda",
                "Borgaon",
                "Budni",
                "Burhanpur",
                "Burhar",
                "Buxwaha",
                "Chachaura-Binaganj",
                "Chakghat",
                "Chandameta Butaria",
                "Chanderi",
                "Chandia",
                "Chandla",
                "Chaurai Khas",
                "Chhapiheda",
                "Chhatarpur",
                "Chhattarpur",
                "Chhindwara",
                "Chhipabad",
                "Chhota Chhindwara",
                "Chichli",
                "Chicholi",
                "Chitrakoot",
                "Churhat",
                "Daboh",
                "Dabra",
                "Dahi",
                "Damoh",
                "Damua",
                "Datia",
                "Dehrisaray",
                "Deodara",
                "Deohara",
                "Deori",
                "Deori, Shahdol District",
                "Depalpur",
                "Devendranagar",
                "Dewas",
                "Dhamnod",
                "Dhamnod Ratlam District",
                "Dhana",
                "Dhanpuri Nargada Hari Dafai",
                "Dhar",
                "Dharampuri",
                "Dhodaramohar Alias Bhoura",
                "Dighawani",
                "Diken",
                "Dindori",
                "Dola",
                "Dongar Parasia",
                "Dumar Kachhar",
                "Dungariya Chhapara",
                "Emlikheda Industrial Area",
                "Gadarwara",
                "Gairatganj",
                "Gamiria Sagar",
                "Gandhi Sagar Haidel",
                "Garhakota",
                "Garhi -Malhara",
                "Garoth",
                "Garra",
                "Gautampura",
                "Ghansaur",
                "Ghoda Dongri Ryt",
                "Ghuwara",
                "Gogapur",
                "Gohad",
                "Gormi",
                "Govindgarh",
                "Guna",
                "Gurh",
                "Gwalior",
                "Hanumana",
                "Harda",
                "Harduli",
                "Harpalpur",
                "Harrai",
                "Harsud",
                "Hat Piplia",
                "Hatod",
                "Hatpiplya",
                "Hatta",
                "Hindoria",
                "Hirapur",
                "Hirdepur",
                "Hoshangabad",
                "Ichhawar",
                "Iklehra",
                "Indergarh",
                "Indore",
                "Industrial Area Jagakhedi",
                "Isagarh",
                "Itarsi",
                "Jabalpur",
                "Jabera",
                "Jaisinghnagar",
                "Jaithari",
                "Jaitpur",
                "Jaitpur Chhatarpur District",
                "Jaitwara",
                "Jamai",
                "Jaora",
                "Jata Chhapar",
                "Jatara",
                "Jawad",
                "Jawar",
                "Jaypee Nagar",
                "Jeron Khalsa",
                "Jhabua",
                "Jhundpura",
                "Jiran",
                "Jirapur",
                "Jobat",
                "Joura",
                "Kailaras",
                "Kakarhati",
                "Kali Chhapar",
                "Kanad",
                "Kannod",
                "Kantaphod",
                "Kareli",
                "Karera",
                "Kari",
                "Karnawad",
                "Karrapur",
                "Kasrawad",
                "Katangi",
                "Katangi, Jabalpur District",
                "Kelhauri",
                "Keolari",
                "Khacharod",
                "Khairi",
                "Khajuraho",
                "Khand",
                "Khandwa",
                "Khaniyadhana",
                "Khargapur",
                "Khargone",
                "Khategaon",
                "Khetia",
                "Khilchipur",
                "Khirkiya",
                "Khor",
                "Khujner",
                "Khurai",
                "Kirnapur",
                "Kolar",
                "Kolaras",
                "Kosmi",
                "Kotar",
                "Kothi",
                "Kothri",
                "Kotma",
                "Kukdeshwar",
                "Kukshi",
                "Kumbhraj",
                "Kundam",
                "Kurwai",
                "Kymore",
                "Ladhaura",
                "Lahar",
                "Lakhnadon",
                "Lanji",
                "Lateri",
                "Laundi",
                "Lodhikheda",
                "Loharda",
                "Machalpur",
                "Madai",
                "Madhawgdha",
                "Maharajpur",
                "Maheshwar",
                "Mahidpur",
                "Mahura",
                "Maihar",
                "Maihar Cement Factory Sarlanagar",
                "Majhgawan",
                "Majhgawan Jabalpur District",
                "Majhgawan Township",
                "Majholi",
                "Makdon",
                "Makronia Buzurg",
                "Maksi",
                "Malajkhand",
                "Malanpur Industrial Area",
                "Malhargarh",
                "Maliya Guda",
                "Manasa",
                "Manawar",
                "Mandideep",
                "Mandla",
                "Mandleshwar",
                "Mandsaur",
                "Mandu",
                "Maneri Industrial Growth Centre",
                "Mangalya",
                "Mangawan",
                "Manpur",
                "Mau",
                "Mauganj",
                "Meghnagar",
                "Mehgaon",
                "Mhow",
                "Mihona",
                "Mohgaon",
                "Morar Cantt",
                "Morena",
                "Multai",
                "Mundi",
                "Mungaoli",
                "Murwara Katni",
                "Nagda",
                "Nagod",
                "Nagri",
                "Nai-Garhi",
                "Nainpur",
                "Nalkheda",
                "Namli",
                "Nanpur",
                "Narayangarh",
                "Narsimhapur",
                "Narsingarh",
                "Narsinghgarh",
                "Narwar",
                "Nasrullaganj",
                "Naudhia",
                "Neemuch",
                "Nepanagar",
                "New Harsud",
                "Newton Chikhli Kalan",
                "Niwari",
                "Niwas",
                "Nowgong",
                "Nowrozabad",
                "Omkareshwar",
                "Orchha",
                "Ordnance Factory Itarsi",
                "Pachmarhi",
                "Pachore",
                "Pal Chaurai",
                "Palera",
                "Palsud",
                "Panagar",
                "Panara",
                "Pandhana",
                "Pandhurna",
                "Pandhurna Industrial Area",
                "Pankhedi",
                "Panna",
                "Pansemal",
                "Pasan",
                "Patan",
                "Patharia",
                "Pawai",
                "Petlawad",
                "Phuphkalan",
                "Pichhore",
                "Pichhore, Gwalior District",
                "Pindrai",
                "Pipalrawan",
                "Pipariya",
                "Pipariya Jabalpur District",
                "Pipariya, Jabalpur District",
                "Piplanarayanwar",
                "Piploda",
                "Piplya Mandi",
                "Pipri",
                "Pithampur",
                "Pithampur Industrial Hub",
                "Polaykalan",
                "Porsa",
                "Prithvipur",
                "Purena",
                "Raghogarh",
                "Rahatgarh",
                "Raisen",
                "Rajakhedi",
                "Rajgarh",
                "Rajgarh, Dhar District",
                "Rajnagar",
                "Rajpur",
                "Rampur",
                "Rampur Baghelan",
                "Rampura",
                "Ranapur",
                "Ranipur",
                "Ratangarh",
                "Ratlam",
                "Rau",
                "Raymond Chhindwara",
                "Raymond Colony Vijay Gram",
                "Rehli",
                "Rehti",
                "Rewa",
                "Rosera",
                "Sabalgarh",
                "Sabo",
                "Sagar",
                "Sailana",
                "Sanawad",
                "Sanchi",
                "Sangvi",
                "Sanjay Gandhi Thermal Power Station",
                "Sanwer",
                "Sarangpur",
                "Sardarpur",
                "Sarni",
                "Satai",
                "Satna",
                "Satwas",
                "Sausar",
                "Sehore",
                "Semaria",
                "Sendhwa",
                "Seondha",
                "Seoni",
                "Seoni-Malwa",
                "Sethiya",
                "Shahdol",
                "Shahgarh",
                "Shahpur",
                "Shahpur, Betul District",
                "Shahpur, Sagar District",
                "Shahpura",
                "Shahpura, Jabalpur District",
                "Shajapur",
                "Shamgarh",
                "Shamshabad",
                "Sheopur",
                "Shivpuri",
                "Shujalpur",
                "Sidgunwa Industrial Area",
                "Sidhi",
                "Sihora",
                "Silwani",
                "Singoli",
                "Singrauli",
                "Sinhasa",
                "Sirgora",
                "Sirmaur",
                "Sironj",
                "Sitamau",
                "Siya Industrial Area",
                "Sohagi",
                "Sohagpur",
                "Sonkatch",
                "Soyatkalan",
                "Sultanpur",
                "Susner",
                "Suswasara",
                "Suthaliya",
                "Tal",
                "Talen",
                "Tarana",
                "Taricharkalan",
                "Tekanpur",
                "Tendukheda",
                "Tendukheda Damoh District",
                "Teonthar",
                "Thandla",
                "Tikamgarh",
                "Timarni",
                "Tirodi",
                "Tonk Khurd",
                "Ubaidullahganj",
                "Udaipura",
                "Udaypur",
                "Ujjain",
                "Ukwa",
                "Umaria",
                "Unchahara",
                "Unhel",
                "Vidisha",
                "Vijaypur Sheopur District",
                "Vijayraghavgarh",
                "Vindhya Nagar NTPC",
                "Waraseoni",
            ],
        },
        {
            name: "Maharashtra",
            code: "MH",
            cities: [
                "Aamby Valley",
                "Achalpur",
                "Achalpur MIDC",
                "Additional Chandrapur MIDC",
                "Aheri",
                "Ahmadnagar",
                "Ahmadpur",
                "Ahmadpur MIDC",
                "Ajanta",
                "Ajara",
                "Ajara MIDC",
                "Akkalkot",
                "Akkalkuwa",
                "Akluj",
                "Akola",
                "Akot",
                "Alandi",
                "Alephata",
                "Alibag",
                "Allapalli",
                "Amalner",
                "Amalner MIDC",
                "Ambad",
                "Ambarnath",
                "Ambejogai",
                "Ambepur",
                "Ambivali Tarf Wankhal",
                "Amboli",
                "Amgaon",
                "Amravati",
                "Anjangaon",
                "Anjarle",
                "Arvi",
                "Asangaon",
                "Asangaon Industrial Area",
                "Ashta",
                "Ashti",
                "Ashti Gadchiroli District",
                "Ashti MIDC",
                "Ashti Wardha District",
                "Atgaon Industrial Complex",
                "Aurangabad",
                "Ausa",
                "Awalpur",
                "Babhaleshwar",
                "Babhulgaon",
                "Badlapur",
                "Balapur",
                "Balapur Akola District",
                "Balapur MIDC",
                "Ballarpur",
                "Banda",
                "Baramati",
                "Barshi",
                "Basmat MIDC",
                "Basmath",
                "Bela",
                "Bhabale MIDC",
                "Bhadgaon",
                "Bhadravati",
                "Bhadravati MIDC",
                "Bhalar Township",
                "Bhandara",
                "Bhandara MIDC",
                "Bhatkuli",
                "Bhatkuli MIDC",
                "Bhiwandi",
                "Bhiwapur",
                "Bhiwapur MIDC",
                "Bhokar",
                "Bhokardan",
                "Bhor",
                "Bhum",
                "Bhusawal",
                "Bhusawal MIDC",
                "Bid",
                "Biloli",
                "Birwadi",
                "Bisur",
                "Boisar",
                "Borgaon",
                "Bori",
                "Borivali Tarf Rahur",
                "Borkhedi",
                "Borli Panchtan",
                "Brahmanvel MIDC",
                "Brahmapuri",
                "Budhagon",
                "Budhgaon",
                "Buldana",
                "Butibori",
                "Butibori MIDC",
                "Chakan",
                "Chalisgaon",
                "Chandgad",
                "Chandrapur",
                "Chandrapur CGGC",
                "Chandrapur MIDC",
                "Chandur",
                "Chandur Amravati District",
                "Chandurbazar",
                "Chandvad",
                "Chicholi",
                "Chikhala",
                "Chikhaldara",
                "Chikhli",
                "Chimur",
                "Chinchani",
                "Chincholi MIDC",
                "Chiplun",
                "Chitegaon",
                "Chopda",
                "Chowk",
                "Dabhol",
                "Dadar",
                "Dahanu",
                "Dahivadi",
                "Dandi",
                "Dapoli",
                "Dapoli Camp",
                "Darwha",
                "Daryapur Banosa",
                "Dattapur Dhamangaon",
                "Daund",
                "Deglur",
                "Deglur MIDC",
                "Dehu",
                "Dehu Cantt",
                "Deogiri",
                "Deola",
                "Deolali Pravara",
                "Deoli",
                "Deoni",
                "Deori",
                "Desaiganj",
                "Deulgaon Raja",
                "Deulgaon Raja MIDC",
                "Devgad",
                "Devrukh",
                "Dharangaon",
                "Dharmabad",
                "Dharni",
                "Dharni MIDC",
                "Dharur",
                "Dharur MIDC",
                "Dhopatala",
                "Dhule",
                "Digras",
                "Dindori",
                "Dindori MIDC",
                "Dodamarg",
                "Dondaicha Warwade",
                "Dombivli",
                "Dudhani",
                "Durgapur",
                "Eklahare",
                "Elephanta Caves",
                "Ellora",
                "Erandol",
                "Etapalli",
                "Faizpur",
                "Gadchiroli",
                "Gadhinglaj",
                "Gadhinglaj MIDC",
                "Gane MIDC",
                "Ganeshpur",
                "Gangakhed",
                "Gangapur",
                "Ganpatipule",
                "Gargoti",
                "Genesis Industrial Township",
                "Georai",
                "Ghansawangi",
                "Ghatanji",
                "Ghoti",
                "Ghugus",
                "Ghulewadi",
                "Gokunda",
                "Gondia MIDC",
                "Gondiya",
                "Gondpipri",
                "Goregaon",
                "Goregaon Gondiya District",
                "Goregaon MIDC",
                "Guhagar",
                "Hadgaon",
                "Hajarmachi",
                "Halkarni MIDC",
                "Harihareshwar",
                "Harsul",
                "Hatkanangle",
                "Himayatnagar",
                "Hindnagar",
                "Hinganghat",
                "Hinganghat MIDC",
                "Hingna",
                "Hingoli",
                "Hingoli MIDC",
                "Honad Industrial Area",
                "Hudkeshwar",
                "Hupari",
                "Ichalkaranji",
                "Igatpuri",
                "Indapur",
                "Indapur MIDC",
                "Jafrabad",
                "Jafrabad MIDC",
                "Jalgaon",
                "Jalgaon Jamod",
                "Jalkot",
                "Jalna",
                "Jalochi",
                "Jamkhed",
                "Jamner",
                "Jath",
                "Jawhar",
                "Jawharnagar",
                "Jaysingpur",
                "Jejuri",
                "Jejuri MIDC",
                "Jintur",
                "Jintur MIDC",
                "Jiwati",
                "Junnar",
                "Kabnur",
                "Kadegaon",
                "Kadegaon MIDC",
                "Kagal",
                "Kagal MIDC",
                "Kaij",
                "Kalamb",
                "Kalameshwar",
                "Kalameshwar MIDC",
                "Kalamnuri",
                "Kallam",
                "Kalmath",
                "Kalwan",
                "Kalyan",
                "Kamalapur MIDC",
                "Kambe",
                "Kamptee",
                "Kamptee Cantt",
                "Kamshet",
                "Kandari",
                "Kandhar",
                "Kandhar MIDC",
                "Kandri",
                "Kandri Mines",
                "Kandri Nagpur",
                "Kanhan",
                "Kanhe Industrial Area",
                "Kanholibara",
                "Kankavli",
                "Kannad",
                "Karad",
                "Karalewadi",
                "Karanja",
                "Karjat",
                "Karjat Ahmadnagar District",
                "Karmala",
                "Kasara",
                "Katangi Kala",
                "Katol",
                "Katol MIDC",
                "Kavalapur",
                "Kavathe Mahankal",
                "Kelapur",
                "Khamari",
                "Khamgaon",
                "Khanapur",
                "Khandala",
                "Khandala Satara",
                "Khandbara",
                "Khapa",
                "Khapar",
                "Kharbav",
                "Khardi",
                "Khatav",
                "Khed",
                "Kherdi",
                "Khopoli",
                "Kinwat",
                "Kolhapur",
                "Kolki",
                "Kondumal",
                "Kopargaon",
                "Koradi",
                "Korchi",
                "Koregaon",
                "Koregaon Bhima",
                "Korochi",
                "Krushnoor MIDC",
                "Kudal",
                "Kudal MIDC",
                "Kudus",
                "Kuhi",
                "Kumbhari",
                "Kundalwadi",
                "Kurduwadi",
                "Kurduwadi MIDC",
                "Kurkheda",
                "Kurkumbh MIDC",
                "Kurul",
                "Kurundvad",
                "Kusgaon Budruk",
                "Lakhamapur MIDC",
                "Lakhandhur",
                "Lakshmi Cooperative Industrial Estate",
                "Lanja",
                "Lasalgaon",
                "Lat",
                "Latur",
                "Latur Industrial Area Additional",
                "Lavasa",
                "Loha",
                "Lohara",
                "Lohara Osmanabad",
                "Lonand",
                "Lonar",
                "Lonavala",
                "Loni",
                "Loni kalbhor",
                "Lote Parshuram MIDC",
                "Madangad",
                "Madha",
                "Madhavnagar",
                "Mahabaleshwar",
                "Mahad",
                "Mahad MIDC",
                "Mahad MIDC Additional",
                "Mahadula",
                "Mahagaon",
                "Mahagaon MIDC",
                "Mahapoli",
                "Mahoor",
                "Maindargi",
                "Majgaon",
                "Makranifali",
                "Malde",
                "Malegaon",
                "Malegaon Jahangir",
                "Malegaon MIDC",
                "Malkapur",
                "Malkapur Buldana District",
                "Malkapur MIDC",
                "Malshiras",
                "Malwan",
                "Manchar",
                "Mandur",
                "Mangalvedha",
                "Mangrulpir",
                "Mangrulpir MIDC",
                "Manjlegaon",
                "Manmad",
                "Manor",
                "Manora",
                "Mansar",
                "Mantha",
                "Manwath",
                "Maregaon",
                "Matheran",
                "Mauda",
                "Medha",
                "Mehkar",
                "Mehkar MIDC",
                "Mhasla",
                "Mhaswad",
                "MIHAN",
                "Mohadi",
                "Mohadi MIDC",
                "Mohol",
                "Mohol MIDC",
                "Mohpa",
                "Mohpada Alias Wasambe",
                "Mokhada",
                "Morshi",
                "Morshi MIDC",
                "Motala",
                "Mouje Anjanvel",
                "Mowad",
                "Mudkhed",
                "Mukhed",
                "Muktainagar",
                "Mul",
                "Mul MIDC",
                "Mulchera",
                "Mumbai",
                "Murbad",
                "Murbad MIDC",
                "Murgud",
                "Murmadi",
                "Murtajapur",
                "Murud",
                "Murum",
                "Musalgaon MIDC",
                "Nagbhid MIDC",
                "Nagbhind",
                "Nagothana",
                "Nagpur",
                "Naigaon",
                "Nakoda",
                "Naldurg",
                "Nampur",
                "Nanda",
                "Nanded Waghala",
                "Nandgaon",
                "Nandgaon Khandeshwar",
                "Nandgaon Pode",
                "Nandgaon Tarf Birwadi",
                "Nandgaonpeth MIDC",
                "Nandura",
                "Nandurbar",
                "Narkher",
                "Nashik",
                "Natepute",
                "Navapur",
                "Ner",
                "Neral",
                "Newasa",
                "Nijampur",
                "Nilanga",
                "Nimbhore Budruk",
                "Niphad",
                "Nira",
                "Ordnance Factory Bhadravati",
                "Osmanabad",
                "Ozar",
                "Pachora",
                "Padagha",
                "Padoli",
                "Paithan",
                "Palam",
                "Palghar",
                "Pali",
                "Palus",
                "Palus MIDC",
                "Pampalner",
                "Panchgani",
                "Pandare MIDC",
                "Pandharkaoda",
                "Pandharpur",
                "Panhala",
                "Paranda",
                "Paratwada",
                "Parbhani",
                "Parli",
                "Parner",
                "Parola",
                "Parshioni",
                "Partur",
                "Partur MIDC",
                "Patalganga MIDC",
                "Patan",
                "Patan MIDC",
                "Pathan MIDC",
                "Pathardi",
                "Pathri",
                "Patoda",
                "Patur",
                "Pauni",
                "Peint",
                "Peint MIDC",
                "Pen",
                "Phaltan",
                "Pimpalgaon Baswant",
                "Pimpri Chinchwad",
                "Pipri",
                "Pirangut",
                "Poladpur",
                "Pombhurna",
                "Pulgaon",
                "Pune",
                "Purna",
                "Purushottamnagar",
                "Pusad",
                "Pusad MIDC",
                "Radhanagari",
                "Rahata",
                "Rahimatpur",
                "Rahuri",
                "Rajapur",
                "Rajgurunagar",
                "Rajur",
                "Rajur Ahmadnagar District",
                "Rajura",
                "Ralegaon",
                "Ramtek",
                "Ranjangaon",
                "Ranjangaon MIDC",
                "Rasal Industrial Area",
                "Ratnagiri",
                "Raver",
                "Rees",
                "Renapur",
                "RIL Township",
                "Risod",
                "Roha Ashtami",
                "Roha MIDC",
                "Sadak Arjuni",
                "Sadavali MIDC",
                "Saidapur",
                "Sakoli",
                "Sakri",
                "Salekasa",
                "Samudrapur",
                "Samudrapur MIDC",
                "Sanaswadi",
                "Sangameshwar",
                "Sangamner",
                "Sangamner MIDC",
                "Sangli Miraj Kupwad",
                "Sangole",
                "Saoner MIDC",
                "Sasti",
                "Sasvad",
                "Satana",
                "Satara",
                "Savda",
                "Savner",
                "Sawali",
                "Sawangi Megh",
                "Sawantwadi",
                "Seloo",
                "Selu",
                "Sengaon",
                "Shahada",
                "Shahapur",
                "Shahapur Bhandara District",
                "Shani Shingnapur",
                "Shegaon",
                "Shendra MIDC",
                "Shendurjana",
                "Shevgaon",
                "Shikrapur",
                "Shinde MIDC",
                "Shirala",
                "Shirala MIDC",
                "Shirdi",
                "Shirgaon",
                "Shirgaon Industrial Area",
                "Shirol",
                "Shirpur",
                "Shirur",
                "Shirur Anantpal",
                "Shirur Kasar",
                "Shirwal",
                "Shivaji Nagar",
                "Shrigonda",
                "Shrirampur",
                "Shrivardhan",
                "Sillewara",
                "Sillod",
                "Sindewahi",
                "Sindewahi MIDC",
                "Sindi",
                "Sindkhed Raja",
                "Sindkheda",
                "Singnapur Kopargaon",
                "Sinnar",
                "Sinnar MIDC",
                "Sironcha",
                "Solapur",
                "Sonai",
                "Sonegaon",
                "Songirwadi",
                "Sonpeth",
                "Supa MIDC",
                "Surgana",
                "Tadali",
                "Takalghat",
                "Takwe Industrial Area",
                "Tala",
                "Talasari",
                "Talegaon Dabhade",
                "Talegaon MIDC",
                "Taloda",
                "Tarapur",
                "Tarapur Textile Park",
                "Tasawade MIDC",
                "Tasgaon",
                "Tekadi",
                "Telhara",
                "Tembhurni MIDC",
                "Thana",
                "Thane",
                "Tirora",
                "Tirora MIDC",
                "Toranmal",
                "Totaladoh",
                "Trimbak",
                "Tuljapur",
                "Tumsar",
                "Tumsar Road",
                "Udgir",
                "Umarga",
                "Umarga MIDC",
                "Umarkhed",
                "Umarsara",
                "Umbar Pada Nandade",
                "Umred",
                "Umred MIDC",
                "Umri",
                "Uran Islampur",
                "Urjagram",
                "Usar MIDC",
                "Utekhol",
                "Vada",
                "Vadgaon",
                "Vaduj",
                "Vaibhawadi",
                "Vaijapur",
                "Vaijapur MIDC",
                "Vangani",
                "Vanvadi",
                "Varangaon",
                "Vasai Virar",
                "Vasantnagar",
                "Vashind",
                "Velhe",
                "Vengurla",
                "Vijay Durg",
                "Vikramgad",
                "Vile Bhagad MIDC",
                "Vinchur",
                "Vinchur MIDC",
                "Visapur",
                "Vita",
                "Vita MIDC",
                "Wada",
                "Wadgaon",
                "Wadi Ratnagiri",
                "Wadwani",
                "Waghapur",
                "Waghoda",
                "Wai",
                "Wai MIDC",
                "Walani",
                "Waluj MIDC",
                "Walwa",
                "Wani",
                "Wardha",
                "Warora",
                "Warora MIDC",
                "Warthi",
                "Warud",
                "Warud MIDC",
                "Washi",
                "Washim",
                "WCL Umred",
                "Yavatmal",
                "Yavatmal Industrial Area",
                "Yawal",
                "Yeola",
                "Yerkheda",
            ],
        },
        {
            name: "Manipur",
            code: "MN",
            cities: [
                "Andro",
                "Bishnupur",
                "Heirok",
                "Imphal",
                "Jiribam",
                "Kakching",
                "Kakching Khunou",
                "Kangpokpi",
                "Kumbi",
                "Kwakta",
                "Lamlai",
                "Lamsang",
                "Lilong",
                "Lilong Imphal West",
                "Lilong Thoubal",
                "Mayang Imphal",
                "Moirang",
                "Moreh",
                "Nambol",
                "Ningthoukhong",
                "Oinam",
                "Samurou",
                "Samurou, Imphal West District",
                "Sekmai Bazar",
                "Senapati",
                "Sikhong Sekmai",
                "Sugnu",
                "Tamenglong",
                "Thongkhong Laxmi Bazar",
                "Thoubal",
                "Torban",
                "Ukhrul",
                "Wangjing",
                "Wangoi",
                "Yairipok",
                "Zenhang Lamka",
            ],
        },
        {
            name: "Meghalaya",
            code: "ML",
            cities: [
                "Baghmara",
                "Cherrapunjee",
                "Jowai",
                "Mairang",
                "Mawlai",
                "Nongpoh",
                "Nongstoin",
                "Resubelpara",
                "Shillong",
                "Tura",
                "Umroi",
                "Williamnagar",
            ],
        },
        {
            name: "Mizoram",
            code: "MZ",
            cities: [
                "Aizawl",
                "Bairabi",
                "Biate",
                "Champhai",
                "Darlawn",
                "Hnahthial",
                "Khawhai",
                "Khawzawl",
                "Kolasib",
                "Lawngtlai",
                "Lengpui",
                "Lunglei",
                "Mamit",
                "N Kawnpui",
                "N Vanlaiphai",
                "Saiha",
                "Sairang",
                "Saitual",
                "Serchhip",
                "Thenzawl",
                "Tlabung",
                "Vairengte",
                "Zawlnuam",
            ],
        },
        {
            name: "Nagaland",
            code: "NL",
            cities: [
                "Changtongya",
                "Chumukedima",
                "Dimapur",
                "Jalukie",
                "Kiphire",
                "Kohima",
                "Longleng",
                "Medziphema",
                "Mokokchung",
                "Mon Town",
                "Naginimora",
                "Peren",
                "Pfutsero",
                "Phek",
                "Satakha",
                "Tseminyu",
                "Tuensang",
                "Tuli",
                "Tzudikong",
                "Wokha",
                "Zunheboto",
            ],
        },
        {
            name: "Orissa",
            code: "OR",
            cities: [
                "Agastinuagan",
                "Anandapur",
                "Anandpur",
                "Anjira",
                "Anjira Jagatsinghapur District",
                "Anugul",
                "Arjyapalli",
                "Asika",
                "Athagad",
                "Athmallik",
                "Badagada",
                "Badakodanda",
                "Badamba",
                "Badmal",
                "Balagoda",
                "Balakati",
                "Balangir",
                "Baleshwar",
                "Baliguda",
                "Balimela",
                "Balipatapur",
                "Balugaon",
                "Banapur",
                "Bandhbahal",
                "Bangomunda",
                "Bangura",
                "Banki",
                "Barapali",
                "Barbil",
                "Bardol",
                "Bargarh",
                "Baripada",
                "Basudebpur",
                "Baudhgarh",
                "Belagachhia",
                "Bellaguntha",
                "Belpahar",
                "Berhampur",
                "Bhadrak",
                "Bhakarsahi",
                "Bhanjanagar",
                "Bhapur",
                "Bhatli",
                "Bhawanipatna",
                "Bhuban",
                "Bhubaneswar",
                "Bhushan Steel Plant Jharsuguda",
                "Bhushan Steel Plant Meramandali",
                "Bijepur",
                "Binika",
                "Biramitrapur",
                "Birapratappur",
                "Bishama Katak",
                "Bonaigarh",
                "Borigam",
                "Boriguma",
                "Brahmabarada",
                "Brajarajnagar",
                "Budhapanka",
                "Buguda",
                "Bundia",
                "Burla",
                "Byasanagar",
                "Champua",
                "Chandapur",
                "Chandili",
                "Charibatia",
                "Chhatrapur",
                "Chikiti",
                "Chitrakonda",
                "Choudwar",
                "Cuttack",
                "Dadhapatna",
                "Daitari",
                "Damanjodi",
                "Danara",
                "Daringbadi",
                "Debagarh",
                "Dera Colliery Township",
                "Dhamanagar",
                "Dhenkanal",
                "Digapahandi",
                "Dungamal",
                "FCI Township",
                "G Udayagiri",
                "Ganjam",
                "Ghantapada",
                "Ghatagaon",
                "GMR Power Plant Kmalanga",
                "Godiputamatiapara",
                "Golabandha",
                "Gopalpur",
                "Gotamara",
                "Gourdanda",
                "Gudari",
                "Gunupur",
                "Hinjilicut",
                "Hirakud",
                "IB Themal Power Plant Banharpali",
                "IMFA Therubali",
                "Indipur",
                "Itamati",
                "Jagatsinghapur",
                "Jajanga",
                "Jajapur",
                "Jaleswar",
                "Jashipur",
                "Jatani",
                "Jeypur",
                "Jharsuguda",
                "Jhumpura",
                "Joda",
                "JSPL Town Anugul",
                "Junagarh",
                "Kabatabandha",
                "Kaipadar",
                "Kalarangiata",
                "Kaliapani",
                "Kalinga Nagar Industrial Area",
                "Kalyanasingpur",
                "Kamakshyanagar",
                "Kanheipur",
                "Kansbahal",
                "Kantabanji",
                "Kantilo",
                "Karanjia",
                "Kashinagara",
                "Kavisurjyanagar",
                "Kendrapara",
                "Kendujhar",
                "Kesinga",
                "Khaliapali",
                "Khalikote",
                "Khandapada",
                "Khariar",
                "Khariar Road",
                "Khatiguda",
                "Khordha",
                "Kochinda",
                "Kodala",
                "Koida",
                "Konark",
                "Koraput",
                "Kotpad",
                "Krushnanandapur",
                "Kuanrmunda",
                "Kukudakhandi",
                "Kullada",
                "Kunjabangarh",
                "L And T Cement Plant Jharsuguda",
                "Lanjigarh",
                "Lathikata",
                "Lochapada",
                "Loisinga",
                "Madanpur Rampur",
                "Majhihara",
                "Makundapur",
                "Malkangiri",
                "Meghahatuburu",
                "Mohana",
                "Mukhiguda",
                "Mundamarai",
                "Nabarangapur",
                "Nalco",
                "Nayagarh",
                "New Lalsingi",
                "Nilagiri",
                "Nimapada",
                "NTPC Kaniha",
                "Nuahata",
                "Nuapatna",
                "OCL Industrial Township",
                "Odagaon",
                "Padmapur",
                "Palalahada",
                "Palurgada",
                "Papadahandi",
                "Paradip",
                "Parlakhemundi",
                "Pathar",
                "Patnagarh",
                "Patrapur",
                "Pattamundai",
                "Phulabani",
                "Pipili",
                "Pitala",
                "Polasara",
                "Puri",
                "Purusottampur",
                "R Udayagiri",
                "Raighar",
                "Rairangpur",
                "Rajagangapur",
                "Rajasunakhala",
                "Rambha",
                "Ranapurgada",
                "Rayagada",
                "Redhakhol",
                "Remuna",
                "Rengali",
                "Rengali Dam Project Township",
                "Rourkela",
                "Sambalpur",
                "Saranga",
                "Sayadpur",
                "Sheragada",
                "Sohela",
                "Sonapur",
                "Soro",
                "Subalaya",
                "Sunabeda",
                "Sundargarh",
                "Surada",
                "Surala",
                "Suvani",
                "Talcher",
                "Talcher Thermal Power Station Township",
                "Tangi",
                "Tarbha",
                "Tensa",
                "Tikarpada",
                "Tikarpada Ganjam District",
                "Tipo",
                "Titlagarh",
                "Tusura",
                "Udala",
                "Umarkote",
                "Vedanta Jharsuguda",
                "Venketraipur",
            ],
        },
        {
            name: "Pondicherry",
            code: "PY",
            cities: [
                "Karaikal",
                "Mahe",
                "Puducherry",
                "Thirumalairayan Pattinam",
                "Yanam",
            ],
        },
        {
            name: "Punjab",
            code: "PB",
            cities: [
                "Abohar",
                "Adampur",
                "Ahmedgarh",
                "Ajnala",
                "Akalgarh",
                "Alawalpur",
                "Amargarh",
                "Amloh",
                "Amritsar",
                "Anandpur Sahib",
                "Apra",
                "Aur",
                "Baba Bakala",
                "Baddowal",
                "Badhni Kalan",
                "Balachaur",
                "Banga",
                "Banur",
                "Bareta",
                "Bariwala",
                "Barnala",
                "Baryar",
                "Bassi Pathana",
                "Batala",
                "Bathinda",
                "Beas",
                "Begowal",
                "Beharnpur",
                "Behrampur",
                "Bhabat",
                "Bhadaur",
                "Bhadson",
                "Bhagha Purana",
                "Bhagta BhaiKa",
                "Bhankarpur",
                "Bhattian",
                "Bhawanigarh",
                "Bhikhi",
                "Bhikhiwind",
                "Bhisiana",
                "Bhogpur",
                "Bhucho Mandi",
                "Bhulath",
                "Budha Theh",
                "Budhlada",
                "Bungal",
                "Chamkaur Sahib",
                "Cheema",
                "Chogawan",
                "Chohal",
                "Daper",
                "Dasuya",
                "Dera Baba Nanak",
                "Dera Bassi",
                "Dera Bassi Industrial Area",
                "Dhanaula",
                "Dharamkot",
                "Dhariwal",
                "Dhilwan",
                "Dhuri",
                "Dinanagar",
                "Dirba",
                "Doraha",
                "Faridkot",
                "Fatehgarh Churian",
                "Fazilka",
                "Firozpur",
                "Gardhiwala",
                "Garhshankar",
                "Ghagga",
                "Ghanaur",
                "Ghoh",
                "Giddarbaha",
                "Goindwal",
                "Goniana",
                "Goraya",
                "Gurdaspur",
                "Guru Har Sahai",
                "Hajipur",
                "Halwara",
                "Handiaya",
                "Hariana",
                "Hoshiarpur",
                "Hussainpur",
                "Jagraon",
                "Jaitu",
                "Jalalabad",
                "Jalandhar",
                "Jandiala",
                "Jandiala, Jalandhar District",
                "Jodhan",
                "Jugial",
                "Kalan",
                "Kalanaur",
                "Kapurthala",
                "Karoran",
                "Kartarpur",
                "Kathanian",
                "Khamanon",
                "Khambra",
                "Khanauri",
                "Khanna",
                "Kharar",
                "Khemkaran",
                "Khilchian",
                "Korianwali",
                "Kot Fatta",
                "Kot Ise Khan",
                "Kotkapura",
                "Kotla Nihang",
                "Kurali",
                "Lalru",
                "Leather Complex Industrial Area",
                "Lehragaga",
                "Lohian Khas",
                "Longowal",
                "Ludhiana",
                "Machhiwara",
                "Mahilpur",
                "Majitha",
                "Makhu",
                "Malaut",
                "Malerkotla",
                "Mallanwala Khass",
                "Maloud",
                "Mamun",
                "Mandi Govindgarh",
                "Mansa",
                "Manwal",
                "Maur",
                "Mirpur",
                "Moga",
                "Mohali",
                "Moonak",
                "Morinda",
                "Mubarakpur",
                "Mudal",
                "Mudki",
                "Mukerian",
                "Muktsar",
                "Mullanpur Dakha",
                "Mullanpur Garib Dass",
                "Nabha",
                "Nag Kalan Industrial Area",
                "Nakodar",
                "Nangal",
                "Nangli",
                "Narot Mehra",
                "Nawanshahr",
                "Nehon",
                "Nurmahal",
                "Pathankot",
                "Patiala",
                "Patran",
                "Patti",
                "Payal",
                "Phagwara",
                "Phillaur",
                "Qadian",
                "Rahon",
                "Raikot",
                "Rail",
                "Raipur Rasulpur",
                "Raja Sansi",
                "Rajpura",
                "Rakri",
                "Raman",
                "Ramdas",
                "Rampura Phul",
                "Rayya",
                "Rupnagar",
                "Rurki Kasba",
                "Sahnewal",
                "Saloh",
                "Samana",
                "Samrala",
                "Sanaur",
                "Sangat",
                "Sangrur",
                "Sansarpur",
                "Sarai Khas",
                "Sardulgarh",
                "Satyewala",
                "Shahkot",
                "Sham ChaurasI",
                "Shikar",
                "Sirhind Fatehgarh Sahib",
                "Sri Hargobindpur",
                "Sujanpur",
                "Sultanpur",
                "Sunam",
                "Talwandi Bhai",
                "Talwandi Sabo",
                "Talwara",
                "Tapa",
                "Tarantaran",
                "Tharial",
                "Tibri",
                "Tungaheri",
                "Urmar Tanda",
                "Zira",
                "Zirakpur",
            ],
        },
        {
            name: "Rajasthan",
            code: "RJ",
            cities: [
                "1SGM",
                "3STR",
                "Abu Road",
                "Ahore",
                "Ajeetgarh",
                "Ajmer",
                "Ajolion Ka Khera Industrial Area",
                "Aklera",
                "Aligarh",
                "Alwar",
                "Amet",
                "Antah",
                "Anupgarh",
                "Asind",
                "Atru",
                "Babai",
                "Baggar",
                "Bagru",
                "Bakani",
                "Bali",
                "Balotra",
                "Banasthali",
                "Bandikui",
                "Banera",
                "Bangur Nagar",
                "Banswara",
                "Bar",
                "Baral",
                "Baran",
                "Bari",
                "Bari Sadri",
                "Barmer",
                "Baskhoh",
                "Basni Belima",
                "Bassi",
                "Bay",
                "Bayana",
                "Beawar",
                "Beejoliya Kalan",
                "Begun",
                "Behror",
                "Bewanja Industrial Area",
                "Bhadra",
                "Bhalariya",
                "Bharatpur",
                "Bhavri",
                "Bhawani Mandi",
                "Bhilwara",
                "Bhim",
                "Bhinder",
                "Bhinmal",
                "Bhiwadi",
                "Bhusawar",
                "Bicciwara Industrial Area",
                "Bichhiwara",
                "Bichhri",
                "Bidasar",
                "Bigod",
                "Bikaner",
                "Bilara",
                "Bishangarh",
                "Bissau",
                "BITS Pilani Campus",
                "Boranada Special Economic Zone",
                "Borawar",
                "Budhpura",
                "Bundi",
                "Chaksu",
                "Chawand",
                "Chechat",
                "Chhabra",
                "Chhapar",
                "Chhipabarod",
                "Chhoti Sadri",
                "Chirawa",
                "Chittaurgarh",
                "Chomu",
                "Churu",
                "Danta",
                "Dariba",
                "Dausa",
                "Deeg",
                "Delwara",
                "Deogarh",
                "Deoli",
                "Deshnoke",
                "Dewrighata Industrial Area",
                "Dhariawad",
                "Dhaulpur",
                "Dhorimanna",
                "Didwana",
                "Dudu",
                "Dungargarh",
                "Dungarpur",
                "Emri",
                "Falna",
                "Fatehnagar",
                "Fatehpur",
                "Gajsinghpur",
                "Galiakot",
                "Gangapur",
                "Gangapur City",
                "Garhi",
                "Gharsana",
                "Gogunda",
                "Goredi Chancha",
                "Gothan",
                "Gothra",
                "Govindgarh, Alwar District",
                "Govindgarh, Jaipur District",
                "Govindpur Baori Industrial Area",
                "Goyli",
                "Guhala",
                "Gulabpura",
                "Hamirgarh",
                "Hamirgarh Growth Centre RIICO",
                "Hanumangarh",
                "Hindaun",
                "Hindaun City Industrial Area",
                "Indragarh",
                "Industrial Area Bidiyad",
                "Industrial Area Bigod",
                "Industrial Area Deoli",
                "Industrial Area Gegal",
                "Industrial Area Hathipura",
                "Industrial Area Kaladera",
                "Industrial Area Kanya Kheri",
                "Industrial Area Karauli",
                "Industrial Area Mathania",
                "Industrial Area Napasar",
                "Industrial Area Narbad Khera",
                "Industrial Area Sangaria",
                "Industrial Area Swaroopganj",
                "Islampur",
                "Jahazpur",
                "Jahazpur Industrial Area",
                "Jaipur",
                "Jaisalmer",
                "Jaitaran",
                "Jalor",
                "Jalore Industrial Area",
                "Jamwa Ramgarh",
                "Jhagarwas",
                "Jhalawar",
                "Jhalrapatan",
                "Jhunjhunun",
                "Jobner",
                "Jodhpur",
                "Jodhpur Stone Park Industrial Area",
                "Kaithoon",
                "Kaladwas Industrial Area",
                "Kaman",
                "Kanor",
                "Kanwat",
                "Kapasan",
                "Kaprain",
                "Karanpur",
                "Karauli",
                "Kasba Bonli",
                "Kawai",
                "Kekri",
                "Kelwa",
                "Keshoraipatan",
                "Kesrisinghpur",
                "Khairabad",
                "Khairthal",
                "Khajuwala",
                "Khandela, Baran District",
                "Khandela, Sikar District",
                "Khanpur",
                "Khara",
                "Khatu",
                "Kherli",
                "Kherliganj",
                "Kherwara Chhaoni",
                "Khetri",
                "Kinchan",
                "Kishangarh",
                "Kishangarh Renwal",
                "Kishangarh, Alwar District",
                "Kolayat",
                "Kolvi Mandi Rajendrapur",
                "Kota",
                "Kotputli",
                "Kuchaman City",
                "Kuchera",
                "Kumbhkot",
                "Kumher",
                "Kushalgarh",
                "Lachhmangarh",
                "Ladnu",
                "Lakheri",
                "Lalsot",
                "Losal",
                "Lunkaransar",
                "Mahu Kalan",
                "Mahwa",
                "Makrana",
                "Malpura",
                "Malsisar",
                "Mandalgarh",
                "Mandawa",
                "Mandawar",
                "Mandpiya",
                "Mangrol",
                "Manoharpur",
                "Manoharthana",
                "Marwar Junction",
                "Mathania",
                "Mavli",
                "Mehandipur",
                "Merta City",
                "Merta Road",
                "Modak",
                "Mokalsar",
                "Mount Abu",
                "Mukandgarh",
                "Mundwa",
                "Nadbai",
                "Nagar",
                "Nagaur",
                "Nagaur Industrial Area",
                "Nainwa",
                "Nandri",
                "Napasar",
                "Nasirabad",
                "Nathdwara",
                "Nawa",
                "Nawalgarh",
                "Neem Ka Thana Industrial Area",
                "Neem-Ka-Thana",
                "Neemrana",
                "Newa Talai",
                "Nimbahera",
                "Niwai",
                "Niwai Industrial Area",
                "Nohar",
                "Nokha",
                "Nooan",
                "Padampur",
                "Pali",
                "Parbatsar",
                "Partapur",
                "Partapur Industrial Area",
                "Phalodi",
                "Phalodi Industrial Area",
                "Phulera",
                "Pilani Town",
                "Pilibanga",
                "Pindwara",
                "Pipar City",
                "Pirawa",
                "Pokaran",
                "Pratapgarh",
                "Pushkar",
                "Raila",
                "Raisinghnagar",
                "Rajakhera",
                "Rajaldesar",
                "Rajgarh",
                "Rajgarh, Churu District",
                "Rajsamand",
                "Ramganj Mandi",
                "Ramgarh",
                "Ramgarh, Alwar District",
                "Ramgarh, Sikar District",
                "Rani",
                "Rani Sagar RIICO",
                "Ranthambore",
                "Ratangarh",
                "Ratannagar",
                "Rawatbhata",
                "Rawatsar",
                "Reengus",
                "Renwal",
                "Reodar",
                "RIICO Industrial Area Bassi",
                "RIICO Industrial Area Bidasar",
                "RIICO Industrial Area Bikasar",
                "RIICO Industrial Area Chopanki",
                "RIICO Industrial Area Gudli",
                "RIICO Industrial Area Kharani",
                "RIICO Industrial Area Khushkhera",
                "RIICO Industrial Area Naya Gaon",
                "RIICO Industrial Area Neemrana",
                "RIICO Industrial Area Palsana",
                "RIICO Industrial Area Rajgarh",
                "RIICO Industrial Area Sanchore",
                "RIICO Institutional Area Ranpur",
                "RIICO Industrial Area Rupangarh",
                "Rikhabdeo",
                "Sadri",
                "Sadulshahar",
                "Sagwara",
                "Salasar",
                "Salumbar",
                "Sambhar",
                "Samdari",
                "Sanchore",
                "Sanderao",
                "Sangaria",
                "Sangod",
                "Sapotra",
                "Saradhana RIICO",
                "Sardargarh",
                "Sardarshahar",
                "Sarekhurd Industrial Area RIICO",
                "Sariska",
                "Sarmathura",
                "Sarwar",
                "Satalkheri",
                "Sawa",
                "Sawai Madhopur",
                "Seemalwara",
                "Semari",
                "Shahjahanpur",
                "Shahjahanpur Industrial Area",
                "Shahpura",
                "Shahpura, Bhilwara District",
                "Sheoganj",
                "Shiwar",
                "Sikar",
                "Silora Industrial Area",
                "Singhana",
                "Sirohi",
                "Sirohi Industrial Area",
                "Siwana",
                "Sojat",
                "Sojat Road",
                "Sri Ganganagar",
                "Sri Madhopur",
                "Sri Madhopur Indusrtial Area",
                "Sudarshanpura RIICO",
                "Sujangarh",
                "Suket",
                "Suket Industrail Area",
                "Sumerganj Mandi",
                "Sumerpur",
                "Sumerpur Industrial Area",
                "Sundlak RIICO Baran",
                "Surajgarh",
                "Suratgarh",
                "Swaroopganj",
                "Takhatgarh",
                "Talera",
                "Tapookra",
                "Taranagar",
                "Thana Gazi RIICO",
                "Tijara",
                "Todabhim",
                "Todaraisingh",
                "Todra",
                "Tonk",
                "Tonk Industrial Area",
                "Udaipur",
                "Udaipurwati",
                "Udpura",
                "Uniara",
                "Utarlai",
                "Vijainagar",
                "Vijainagar, Ganganagar District",
                "Viratnagar",
                "Weir",
            ],
        },
        {
            name: "Sikkim",
            code: "SK",
            cities: [
                "Gangtok",
                "Gyalshing",
                "Jorethang",
                "Mangan",
                "Meli",
                "Namchi",
                "Nayabazar",
                "Pelling",
                "Rangpo",
                "Rhenock",
                "Singtam",
                "Upper Tadong",
            ],
        },
        {
            name: "Tamil Nadu",
            code: "TN",
            cities: [
                "VA Vellalapatti",
                "Abiramam",
                "Achampudur",
                "Acharapakkam",
                "Achipatti",
                "Adikaratti",
                "Adiramapattinam",
                "Adiyanuthu",
                "Aduthurai",
                "Agaram",
                "Agastheeswaram",
                "Alagappapuram",
                "Alanganallur",
                "Alangayam",
                "Alangudi",
                "Alangulam",
                "Alangulam, Virudhunagar District",
                "Alanthurai",
                "Alathur, Chengalpattu Taluka",
                "Aliyar",
                "Alur",
                "Alwarkurichi",
                "Alwarthirunagiri",
                "Amathur",
                "Ambasamudram",
                "Ambur",
                "Ammainaickanur",
                "Ammanur",
                "Ammapattinam",
                "Ammapettai",
                "Ammapettai, Erode District",
                "Ammavarikuppam",
                "Ammoor",
                "AMRL Sez Vaigaikulam",
                "Anaimalai",
                "Anaiyur",
                "Ananthapuram",
                "Andipalayam",
                "Andipatti Jakkampatti",
                "Anjugrammam",
                "Annamalai Nagar",
                "Annanji",
                "Annavasal",
                "Annur",
                "Anthiyur",
                "Anuppankulam",
                "Appakudal",
                "Arachalur",
                "Arakandanallur",
                "Arakonam",
                "Aralvaimozhi",
                "Arani",
                "Arani, Thiruvallur District",
                "Aranthangi",
                "Arasiramani",
                "Arasur",
                "Aravakurichi",
                "Arcot",
                "Arimalam",
                "Ariyalur",
                "Ariyappampalayam",
                "Ariyur",
                "Arumanai",
                "Arumbanur",
                "Arumbavur",
                "Arumuganeri",
                "Aruppukkottai",
                "Asaripallam",
                "Athani",
                "Athanur",
                "Athimarapatti",
                "Athipatti",
                "Athur",
                "Athur, Thoothukkudi District",
                "Attayampatti",
                "Attur",
                "Avadattur",
                "Avalapalli",
                "Avalpoondurai",
                "Avanashi",
                "Avaniapuram",
                "Ayakudi",
                "Aygudi",
                "Ayothiapattinam",
                "Ayyalur",
                "Ayyampalayam",
                "Ayyampettai",
                "Ayyampettai, Thanjavur District",
                "Azhagiapandipuram",
                "B Mallapuram",
                "B Meenakshipuram",
                "Balakrishnampatti",
                "Balakrishnapuram",
                "Balapallam",
                "Balasamudram",
                "Bargur",
                "Batlagundu",
                "Belur",
                "Bharathi Nagar",
                "Bhavani",
                "Bhavanisagar",
                "Bhuvanagiri",
                "Bikketti",
                "Bodinayakanur",
                "Boothapandi",
                "Boothipuram",
                "Chakkarapalli",
                "Chathirareddipatti",
                "Chatrapatti",
                "Chenbagaramanputhur",
                "Chengalpattu",
                "Chengam",
                "Chengappalli",
                "Chennagiri",
                "Chennai",
                "Chennasamudram",
                "Chennimalai",
                "Cheranmadevi",
                "Chetpet",
                "Chettiarpatti",
                "Chettipalayam",
                "Chettipalayam, Coimbatore District",
                "Chettithangal",
                "Chidambaram",
                "Chinnakalayamputhur",
                "Chinnakkampalayam",
                "Chinnalapatti",
                "Chinnamanur",
                "Chinnampalayam",
                "Chinnasalem",
                "Chinnathadagam",
                "Chinniampalayam, Erode District",
                "Chinthamani",
                "Chithode",
                "Chockampatti",
                "Cholapuram",
                "Coimbatore",
                "Coonoor",
                "Courtalam",
                "Cuddalore",
                "Damalerimuthur",
                "Dasanaickenpatti",
                "Denkanikottai",
                "Desur",
                "Devadanapatti",
                "Devakottai",
                "Devanangurichi",
                "Devarshola",
                "Devasthanam",
                "Devikapuram",
                "Devipattinam",
                "Dhalavoipuram",
                "Dhali",
                "Dhaliyur",
                "Dharamapuram",
                "Dharapadavedu",
                "Dharapuram",
                "Dharmapuri",
                "Dindigul",
                "Doramangalam",
                "Dusi",
                "Edaganasalai",
                "Edaikodu",
                "Edakalinadu",
                "Edappadi",
                "Elathur",
                "Elayirampannai",
                "ELCOT Gangaikodan IT Park",
                "Ellandaikuttai",
                "Elumalai",
                "Eral",
                "Eranapuram",
                "Eraniel",
                "Eriodu",
                "Erode",
                "Erumaipatti",
                "Eruvadi",
                "Ethapur",
                "Ettayapuram",
                "Ettimadai",
                "Ezhudesam",
                "Frontier Mediville SEZ",
                "Ganapathipuram",
                "Gandhi Nagar",
                "Gangaikondan",
                "Gangavalli",
                "Ganguvarpatti",
                "Gingee",
                "GK Industrial Park",
                "Gobichettipalayam",
                "Gopalasamudram",
                "Gudalur",
                "Gudalur, The Nilgiris District",
                "Gudalur, Theni District",
                "Gudiyatham",
                "Gummidipoondi",
                "Hale Dharmapuri",
                "Hanumanthampatti",
                "Harur",
                "Harveypatti",
                "Highways",
                "Hosur",
                "Hubbathala",
                "Huligal",
                "Idikarai",
                "Iduvai",
                "Ilampillai",
                "Ilanji",
                "Ilayangudi",
                "Iluppaiyurani",
                "Iluppur",
                "Irugur",
                "Jaffrabad",
                "Jalakandapuram",
                "Jambai",
                "Jayankondam",
                "Jeyamangalam",
                "Jolarpet",
                "K Madapur",
                "Kadambathur",
                "Kadambur",
                "Kadathur",
                "Kadayal",
                "Kadayam",
                "Kadayampatti",
                "Kadayanallur",
                "Kailasagiri",
                "Kakkalur",
                "Kalakad",
                "Kalakattupular",
                "Kalambur",
                "Kalappanaickenpatti",
                "Kalavai",
                "Kaliyakkavilai",
                "Kaliyapuram",
                "Kalladaikurichi",
                "Kallakkurichi",
                "Kallakudi",
                "Kallangudy",
                "Kallipalaym",
                "Kallukoottam",
                "Kalparapatti",
                "Kalugumalai",
                "Kamalakannanji SIDCO Industrial Estate",
                "Kamayagoundanpatti",
                "Kambainallur",
                "Kambam",
                "Kamuthi",
                "Kanadukathan",
                "Kanakkampalayam",
                "Kanakkanpatti",
                "Kanam",
                "Kancheepuram",
                "Kandanur",
                "Kangayampalayam",
                "Kangeyam",
                "Kaniyambadi",
                "Kaniyampoondl",
                "Kaniyur",
                "Kaniyur,Coimbatore District",
                "Kanjikoil",
                "Kannamangalam",
                "Kannampalayam",
                "Kannanendal",
                "Kannanoor",
                "Kannivadi",
                "Kannivadi, Dindigul District",
                "Kanniyakumari",
                "Kappalur SIDCO Industrial Estate",
                "Kappiyarai",
                "Karadipatti",
                "Karaikkudi",
                "Karaikudi SIDCO Industrial Estate",
                "Karamadai",
                "Karambakkudi",
                "Kariamangalam",
                "Kariapatti",
                "Karugampattur",
                "Karukkalvadi",
                "Karumandi Chellipalayam",
                "Karumathampatti",
                "Karungal",
                "Karunguzhi",
                "Karuppur",
                "Karur",
                "Kasipalayam",
                "Kathujuganapalli",
                "Kattathurai",
                "Kattumannarkoil",
                "Kattupakkam",
                "Kattuputhur",
                "Kaveripakkam",
                "Kaveripattinam",
                "Kavindapadi",
                "Kayalpattinam",
                "Kayatharu",
                "Keelakarai",
                "Keeramangalam",
                "Keeranur",
                "Keeranur, Pudukkottai District",
                "Keeripatti",
                "Keezhkulam",
                "Kelamangalam",
                "Kembainaickenpalayam",
                "Kethi",
                "Kila Ambur",
                "Kilampadi",
                "Kilapavoor",
                "Kilkunda",
                "Killai",
                "Killiyoor",
                "Kilpennathur",
                "Kilvaithinankuppam",
                "Kilvelur",
                "Kinathukadavu",
                "Kodaikanal",
                "Kodavasal",
                "Kodivalasa",
                "Kodumudi",
                "Koil Palayam",
                "Kolachal",
                "Kolappalur",
                "Kolathupalayam",
                "Kolathur",
                "Kollancode",
                "Kollankoil",
                "Komaralingam",
                "Kombai",
                "Kondur",
                "Konganapuram",
                "Koonavelampatti",
                "Kooraikundu",
                "Koothappar",
                "Koradacheri",
                "Kotagiri",
                "Kothanallur",
                "Kottaiyur",
                "Kottakuppam",
                "Kottaram",
                "Kottur",
                "Kovalam",
                "Kovilpatti",
                "Krishnagiri",
                "Krishnarayapuram",
                "Kuchanur",
                "Kuchipulayam",
                "Kuhalur",
                "Kulappuram",
                "Kulasekaram",
                "Kulasekarapuram",
                "Kulathur",
                "Kulithalai",
                "Kullursandai",
                "Kumaragiri",
                "Kumarapalayam",
                "Kumarapuram",
                "Kumbakonam",
                "Kunnathur",
                "Kurinjipadi",
                "Kurudampalayam",
                "Kurukkupatti",
                "Kurumbalur",
                "Kurumbapatti",
                "Kuruppanaickenpalayam",
                "Kuthalam",
                "Kuthanallur",
                "Kuzhithurai",
                "Labbaikudikadu",
                "Lakkampatti",
                "Lakshmi Puram",
                "Lalgudi",
                "Lalpet",
                "Lampalayam",
                "Madaharpakkam",
                "Madathukulam",
                "Madukkarai",
                "Madukkur",
                "Madurai",
                "Maduranthakam",
                "Mahindra World City",
                "Makkinampatti",
                "Mallankinaru",
                "Mallasamudram",
                "Mallur",
                "Malumichampatti",
                "Mamallapuram",
                "Mamsapuram",
                "Manachanallur",
                "Manalikarai",
                "Manalmedu",
                "Manalurpet",
                "Manamadurai",
                "Manapparai",
                "Manavalakurichi",
                "Mancad",
                "Mandaikadu",
                "Mandapam",
                "Mangalam",
                "Mangalampet",
                "Manimutharu",
                "Mannargudi",
                "Manthithoppu",
                "Maraimalainagar",
                "Marakkanam",
                "Maramangalathupatti",
                "Marandahalli",
                "Markayankottai",
                "Marthandam",
                "Marudur",
                "Marungur",
                "Maruthancode",
                "Masinaickenpatty",
                "Mathicode",
                "Mathigiri",
                "Mathur",
                "Mayiladuthurai",
                "Mecheri",
                "Melacheval",
                "Melachokkanathapuram",
                "Melagaram",
                "Melaparthibanur",
                "Melathiruppanthuruthi",
                "Melattur",
                "Melmangalam",
                "Melpattampakkam",
                "Melur",
                "Melvisharam",
                "Methukummal",
                "Mettamalai",
                "Mettunasuvanpalayam",
                "Mettupalayam",
                "Mettupalayam, Tiruchirappalli District",
                "Mettur",
                "Mevalurkuppam",
                "Milavittan",
                "Minampalli-Pachamadevi",
                "Modakurichi",
                "Mohamed Bundur",
                "Mohanur",
                "Moolakaraipatti",
                "Mopperipalayam",
                "Morattupalayam",
                "Mudalipalayam SIDCO",
                "Mudukulathur",
                "Mudumalai",
                "Mukasipidariyur",
                "Mukkudal",
                "Mulagumudu",
                "Mulanur",
                "Mullipattu",
                "Muruganpalayam",
                "Musiri",
                "Muthanampalayam",
                "Muthukadu",
                "Muthupet",
                "Muthur",
                "Muttayyapuram",
                "Muzhucode",
                "Mylaudy",
                "Nadaikavu",
                "Naduvaneri",
                "Naduvattam",
                "Nagamalaipudukottai",
                "Nagamangalam",
                "Nagapattinam",
                "Nagercoil",
                "Nagojanahalli",
                "Nallampatti",
                "Nallipalayam",
                "Nallur",
                "Namagiripettai",
                "Namakkal",
                "Nambiyur",
                "Nandivaram-Guduvancheri",
                "Nangavalli",
                "Nangavaram",
                "Nanguneri",
                "Nanjaiuthukuli Industrial Estate",
                "Nanjikottai",
                "Nannilam",
                "Naranammalpuram",
                "Naranapuram",
                "Narasimhanaickenpalayam",
                "Narasingapuram",
                "Narasingapuram, Salem District",
                "Nasiyanur",
                "Natchiarkoil",
                "Natham",
                "Nathampannai",
                "Natrampalli",
                "Nattalam",
                "Nattapettai",
                "Nattarasankottai",
                "Nazerath",
                "Needamangalam",
                "Neelagiri",
                "Neikkarapatti",
                "Nellikuppam",
                "Nelliyalam",
                "Nemili",
                "Neripperichal",
                "Nerkuppai",
                "Nerunjipettai",
                "Neyveli",
                "Neyyoor",
                "Nilaiyur",
                "Nilakkottai",
                "O' Valley",
                "Odaipatti",
                "Odaiyakulam",
                "Oddanchatram",
                "Odugathur",
                "Olagadam",
                "Omalur",
                "Ooty",
                "Periyamanali",
                "Periyanaickenpalayam",
                "Pernampattu",
                "Perumagalur",
                "Perumagoundampatti",
                "Perumanallur",
                "Perumandi",
                "Perundurai",
                "Perungulam",
                "Pethampalayam",
                "Pethanaickenpalayam",
                "Pettai",
                "Pillanallur",
                "PJ Cholapuram",
                "Pollachi",
                "Polur",
                "Pongaliyur",
                "Ponmanai",
                "Ponnamaravathi",
                "Ponnampatti",
                "Ponneri",
                "Poolambadi",
                "Poolampatti",
                "Poolankinar",
                "Pooluvapatti",
                "Porayar",
                "Pothanur",
                "Pothatturpettai",
                "Pudiyamputhur",
                "Pudukkottai",
                "Pudupalayam",
                "Pudupalayam Agraharam",
                "Pudupatti",
                "Pudupattinam",
                "Pudur",
                "Puduvayal",
                "Puliankudi",
                "Puliyur",
                "Pullampadi",
                "Punjai Thottakurichi",
                "Punjaipugalur",
                "Punjaipuliampatti",
                "Puthalam",
                "Putheri",
                "Puthukkadai",
                "Puvalur",
                "R Pudupatti",
                "Rajapalayam",
                "Rajapalayam, Salem District",
                "Rakkiya Palayam",
                "Ramalingapuram",
                "Ramanathapuram",
                "Rameswaram",
                "Ranipettai",
                "Rasipuram",
                "Rayagiri",
                "RS Mangalam",
                "Rudravathi",
                "S Kannanur",
                "S Kodikulam",
                "S Nallur",
                "Sakkimangalam",
                "Salangapalayam",
                "Salem",
                "Samalapuram",
                "Samanatham",
                "Samathur",
                "Sambavar Vadagarai",
                "Sankaramanallur",
                "Sankarankoil",
                "Sankaraperi",
                "Sankarapuram",
                "Sankari",
                "Sankarnagar",
                "Sarcarsamakulam",
                "Sathankulam",
                "Sathiyavijayanagaram",
                "Sathyamangalam",
                "Sattur",
                "Sayalgudi",
                "Sayapuram",
                "Seerapalli",
                "Seevur",
                "Seithur",
                "Semmipalayam",
                "Senthamangalam",
                "Sentharapatti",
                "Senur",
                "Sethiathoppu",
                "Sevilimedu",
                "Sevugampatti",
                "Sevur",
                "Shenkottai",
                "Sholavandan",
                "Sholingur",
                "Sholur",
                "SIDCO Bargur",
                "Singampuneri",
                "Singaperumalkoil",
                "Singilipatti",
                "SIPCOT Cheyyar",
                "SIPCOT Industrial Complex Pillaipakkam",
                "SIPCOT Industrial Park Sriprumbudur",
                "SIPCOT Perundurai",
                "SIPCOT Thervoy Kandigal",
                "SIPCOT Thoothukudi",
                "Sircar Periapalayam",
                "Sirkali",
                "Sirugamani",
                "Sirumugai",
                "Sithayankottai",
                "Sithurajapuram",
                "Sivaganga",
                "Sivagiri",
                "Sivagiri, Erode District",
                "Sivagiripatti",
                "Sivagnanapuram",
                "Sivakasi",
                "Sivanthipatti",
                "Sivanthipuram",
                "Srikalikapuram",
                "Srimushnam",
                "Sriperumbudur",
                "Sriramapuram",
                "Srivaikuntam",
                "Srivilliputhur",
                "Suchindrum",
                "Suleeswaranpatti",
                "Sulur",
                "Sundarapandiam",
                "Sundarapandianpattinam",
                "Sundarapandiapuram",
                "Surandai",
                "Suriyampalayam",
                "Swamimalai",
                "T Kallipatti",
                "T Kallupatti",
                "Tajpura",
                "Tayilupatti",
                "Tenkasi",
                "Terkukallikulam",
                "Thadikarankonam",
                "Thadikombu",
                "Thakkolam",
                "Thalainayar",
                "Thamaraikulam",
                "Thammampatti",
                "Thanjavur",
                "Thanthoni",
                "Thappakuttai",
                "Tharamangalam",
                "Tharangambadi",
                "Thathaiyangarpet",
                "Thathankuttai",
                "Thazhakudy",
                "Thedavur",
                "Thenambakkam",
                "Thengampudur",
                "Theni Allinagaram",
                "Thenkarai",
                "Thenkarai, Coimbatore District",
                "Thenthamaraikulam",
                "Thenthiruperai",
                "Therur",
                "Thevaram",
                "Thevarappan Patti",
                "Thevur",
                "Thiagadurgam",
                "Thikkanamcode",
                "Thimmaiyanpettai",
                "Thingalnagar",
                "Thirikoodapuram",
                "Thirukarungavur",
                "Thirukarungudi",
                "Thirukkadaiyur",
                "Thirukkattupalli",
                "Thirumalayampalayam",
                "Thirumalpur",
                "Thirumangalam",
                "Thirumuruganpoondi",
                "Thirunageswaram",
                "Thiruparankundram",
                "Thiruparappu",
                "Thiruporur",
                "Thiruppalai",
                "Thiruppanandal",
                "Thirupuvanam",
                "Thirupuvanam, Thanjavur District",
                "Thiruthangal",
                "Thiruthuraipoondi",
                "Thiruvaiyaru",
                "Thiruvalam",
                "Thiruvallur",
                "Thiruvarur",
                "Thiruvattar",
                "Thiruvenkadam",
                "Thiruvennainallur",
                "Thiruverumbur",
                "Thiruvidaimarudur",
                "Thiruvithancode",
                "Thisayanvilai",
                "Thondamuthur",
                "Thondi",
                "Thookkanaikampalayam",
                "Thorapadi",
                "Thorapadi,Cuddalore District",
                "Thottiyam",
                "Thuraiyur",
                "Thuthipattu",
                "Thuvakudi",
                "Timiri",
                "Tindivanam",
                "Tiruchendur",
                "Tiruchengode",
                "Tiruchirappalli",
                "Tirukalukundram",
                "Tirukkoyilur",
                "Tirumalaigiri",
                "Tirunelveli",
                "Tirupathur",
                "Tirupathur, Vellore District",
                "Tiruppur",
                "Tiruttani",
                "Tiruvannamalai",
                "Tiruvethipuram",
                "Tittacheri",
                "Tittakudi",
                "TNPL Pugalur",
                "Tuticorin",
                "TVS Plant Hosur",
                "Udangudi",
                "Udayarpalayam",
                "Udumalaipettai",
                "Ullur",
                "Ulundurpet",
                "Unjalur",
                "Unnamalaikadai",
                "Uppidamangalam",
                "Uppiliapuram",
                "Usilampatti",
                "Uthamapalayam",
                "Uthangarai",
                "Uthayendram",
                "Uthiramerur",
                "Uthukkottai",
                "Uthukuli",
                "V Pudupatti",
                "V Pudur",
                "Vadakarai Keezhpadugai",
                "Vadakkanandal",
                "Vadakkuvalliyur",
                "Vadalur",
                "Vadamadurai",
                "Vadapudupatti",
                "Vaddakkankulam",
                "Yercaud",
                "Zamin Uthukuli",
            ],
        },
        {
            name: "Telangana",
            code: "TS",
            cities: [
                "Achampet",
                "Adilabad",
                "Alampur",
                "Allipur",
                "Ananthapuram",
                "Anjani Portland Cement Factory",
                "APIIC Polepally SEZ",
                "Armur",
                "Ashwaraopet",
                "Asifabad",
                "Atmakur Mahbubnagar District",
                "Ballepalle",
                "Banswada",
                "Bellampalle",
                "Bhadrachalam",
                "Bhainsa",
                "Bheema Cements Limited Ramapuram",
                "Bhimaram",
                "Bhimaram Warangal District",
                "Bhongir",
                "Bhupalpalle",
                "Bibinagar",
                "Bodhan",
                "Boyapalle",
                "Chandur",
                "Chanukya Cement Factory",
                "Chatakonda",
                "Chegunta",
                "Chelpur",
                "Chennur Adilabad District",
                "Chinnachitakunta",
                "Chitkul",
                "Chityala",
                "Choppadandi",
                "Choutuppal",
                "Chunchupalle",
                "Dasnapur",
                "Deccan Cement Factory",
                "Devapur",
                "Devarakonda",
                "Devarkadra",
                "Dharmapuri",
                "Dharmaram",
                "Dharmaram Karimnagar District",
                "Dharmaram Warangal District",
                "Dornakal",
                "Eddumailaram",
                "Farooqnagar",
                "Gadwal",
                "Gajwel",
                "Ghanpur",
                "Ghanpur Warangal District",
                "Gorrekunta",
                "Gurralapadu Industrial Area",
                "Haliya",
                "Hanwada",
                "Husnabad",
                "Huzur Nagar",
                "Huzurabad",
                "Hyderabad",
                "Ibrahimpatnam Rangareddy District",
                "Ichoda",
                "Ieeja",
                "Isnapur",
                "Jadcherla",
                "Jagtial",
                "Jainoor",
                "Jallaram",
                "Jammikunta",
                "Jangaon",
                "Jannaram",
                "Jogipet",
                "Kaddam Peddur",
                "Kadipikonda",
                "Kagaznagar",
                "Kalwakurthy",
                "Kamalapuram",
                "Kamalapuram Karimnagar District",
                "Kamareddy",
                "Karimnagar",
                "Kasipet",
                "Khammam",
                "Khanapur",
                "Kisan Nagar Industrial Area",
                "Kodad",
                "Kodangal",
                "Kondamallapalle",
                "Koratla",
                "Kosigi",
                "Kothagudem",
                "Kothakota",
                "Kothur",
                "Kyathampalle",
                "Laxmidevipalle",
                "Luxettipet",
                "Madaram",
                "Madhira",
                "Madikonda",
                "Mahabubabad",
                "Mahbubnagar",
                "Maheswaram Industrial Area",
                "Mamda",
                "Mamnoor",
                "Mancherial",
                "Mandamarri",
                "Manugur",
                "Medak",
                "Medipalle",
                "Metapally",
                "Miryalaguda",
                "Muhammadabad",
                "Mulugu",
                "Nagarjuna Sagar",
                "Nagarkurnool",
                "Nakrekal",
                "Nalgonda",
                "Narayanapuram",
                "Narayankhed",
                "Narayanpet",
                "Narsampet",
                "Narsapur",
                "Naspur",
                "Navandgi",
                "Nirmal",
                "Nizamabad",
                "Palakurthy",
                "Palwancha",
                "Pargi",
                "Peddapalle",
                "Perur",
                "Pochampalle",
                "Pothreddipalle",
                "Raasi Cement Factory Wazirabad",
                "Raghunathpur",
                "Ramagundam",
                "Ramannapeta",
                "Ratnapur",
                "Ratnapur Medak District",
                "Rudraram",
                "Rudraram Industrial Area",
                "Sadasivpet",
                "Sangareddy",
                "Sarangapur",
                "Sarapaka",
                "Sathupally",
                "Secunderabad",
                "Shamshabad",
                "Shankarampet",
                "Shivunipalle",
                "Siddipet",
                "Singapuram",
                "Sircilla",
                "Soanpet",
                "Sri Vishnu Cement Limited Dondapadu",
                "Suryapet",
                "Tallada",
                "Tandur",
                "Teegalpahad",
                "Thallapalle",
                "Thimmapur",
                "Thorrur",
                "Turkapally",
                "Utnur",
                "Vatwarlapalle",
                "Vemulawada",
                "Vicarabad",
                "Wanaparthy",
                "Warangal",
                "Warangal Industrial Area",
                "Yadagirigutta",
                "Yellandu",
                "Yellareddy",
                "Yenugonda",
                "Yerrabalem",
                "Zahirabad",
            ],
        },
        {
            name: "Tripura",
            code: "TR",
            cities: [
                "Agartala",
                "Amarpur",
                "Ambassa",
                "Anandanagar",
                "Badharghat",
                "Belonia",
                "Briddhanagar",
                "Dharmanagar",
                "Fatikroy",
                "Gakulnagar",
                "Gakulpur",
                "Gandhigram",
                "Indranagar",
                "Jogendranagar",
                "Kailasahar",
                "Kalachhari",
                "Kamalpur",
                "Kanchanpur",
                "Khowai",
                "Kumarghat",
                "Kunjaban",
                "Madhupur",
                "Manu",
                "Matarbari",
                "Narsingarh",
                "Panisagar",
                "Ranirbazar",
                "Sabroom",
                "Santirbazar",
                "Sonamura",
                "Taranagar",
                "Teliamura",
                "Udaipur",
            ],
        },
        {
            name: "Uttar Pradesh",
            code: "UP",
            cities: [
                "Abupur",
                "Achalganj",
                "Achhalda",
                "Achhnera",
                "Adari",
                "Afzalgarh",
                "Agarwal Mandi",
                "Agra",
                "Agro Park Karkhiyon",
                "Ahraura",
                "Ailum",
                "Air Force Area",
                "Ajhuwa",
                "Akbarpur",
                "Akbarpur Near Kanpur",
                "Aliganj",
                "Aligarh",
                "Allahabad",
                "Allahganj",
                "Allapur",
                "Amanpur",
                "Ambehta",
                "Amethi",
                "Amethi Sultanpur District",
                "Amila",
                "Amilo",
                "Aminagar Sarai",
                "Amraudha",
                "Amroha",
                "Anandnagar",
                "Anpara",
                "Antu",
                "Anupshahr",
                "Anurudhpur Purab Patti",
                "Aonla",
                "Artauni",
                "Ashrafpur Kichhauchha",
                "Atarra",
                "Atasu",
                "Atrauli",
                "Atraulia",
                "Auraiya",
                "Aurangabad",
                "Auras",
                "Awagarh",
                "Ayodhya",
                "Azamgarh",
                "Azmatgarh",
                "Babarpur Ajitmal",
                "Baberu",
                "Babina",
                "Babrala",
                "Babugarh",
                "Bachhgaon",
                "Bachhraon",
                "Bachhrawan",
                "Bad",
                "Badaun Industrial Area",
                "Baghpat",
                "Bah",
                "Bahadurganj",
                "Baheri",
                "Bahjoi",
                "Bahraich",
                "Bahsuma",
                "Bahuwa",
                "Bajna",
                "Bakewar",
                "Bakiabad",
                "Baksar",
                "Bakshi Ka Talab",
                "Baldeo",
                "Ballia",
                "Balrampur",
                "Banat",
                "Banda",
                "Bangarmau",
                "Banguwan Kalan",
                "Banjarepur",
                "Bansdih",
                "Bansgaon",
                "Bansi",
                "Bara Gaon",
                "Barabanki",
                "Barabanki Industrial Area",
                "Baragaon",
                "Barahatir Jagdishpur",
                "Baraut",
                "Bareilly",
                "Barhalganj",
                "Barhani Bazar",
                "Barkhera",
                "Baroun",
                "Barsana",
                "Barua Sagar",
                "Barwar",
                "Barwara Mazra",
                "Basantpur Saitli",
                "Basta",
                "Basti",
                "Beelna",
                "Behat",
                "Behta Hajipur",
                "Bela Pratapgarh",
                "Belthara Road",
                "Beniganj",
                "Benipur",
                "Beswan",
                "Bewar",
                "Bhabnan Bazar",
                "Bhadarsa",
                "Bhadohi",
                "Bhadohi Industrial Area",
                "Bhagwant Nagar",
                "Bharatganj",
                "Bhargain",
                "Bharthana",
                "Bharuhana",
                "Bharwari",
                "Bhatni Bazar",
                "Bhatpar Rani",
                "Bhawan Bahadur Nagar",
                "Bhinga",
                "Bhogaon",
                "Bhojpur Dharampur",
                "Bhokarhedi",
                "Bhulepur",
                "Bidhuna",
                "Bighapur",
                "Bihka",
                "Bijauli Industrial Area",
                "Bijnor",
                "Bijpur",
                "Bikapur",
                "Bilari",
                "Bilariaganj",
                "Bilaspur",
                "Bilaspur, Gautam Buddha Nagar District",
                "Bilgram",
                "Bilhaur",
                "Bilram",
                "Bilsanda",
                "Bilsi",
                "Bindki",
                "Birbhanpur",
                "Bisalpur",
                "Bisanda Buzurg",
                "Bisauli",
                "Bisharatganj",
                "Bishunipur",
                "Biswan",
                "Bithoor",
                "Budaun",
                "Budhana",
                "Bugrasi",
                "Bulandshahr",
                "Chail",
                "Chakia",
                "Chakmano",
                "Chandauli",
                "Chandausi",
                "Chandpur",
                "Charkhari",
                "Charthaval",
                "Chaumuhan",
                "Chaurhat",
                "Chhaprauli",
                "Chharra Rafatpur",
                "Chhata",
                "Chhatari",
                "Chhibramau",
                "Chhitauni",
                "Chhutmalpur",
                "Chilkana Sultanpur",
                "Chirgaon",
                "Chitbara Gaon",
                "Chitrakoot",
                "Chopan",
                "Choubepur Kalan",
                "Chunar",
                "Churk Ghurma",
                "Colonelganj",
                "Dadri",
                "Dalmau",
                "Dankaur",
                "Dariyabad",
                "Dasna",
                "Dataganj",
                "Daurala",
                "Debai",
                "Deoband",
                "Deoranian",
                "Deori Singhpura",
                "Deoria",
                "Deosaini",
                "Derapur",
                "Devinagar",
                "Dewa",
                "Dhakauli",
                "Dhampur",
                "Dhanauha",
                "Dhanaura",
                "Dharoti Khurd",
                "Dhaura Tanda",
                "Dhaurahara",
                "Dibiyapur",
                "Dildarnagar Fatehpur Bazar",
                "Dindaspur",
                "Dindaspur Chandauli District",
                "Doghat",
                "Dohrighat",
                "Domariyaganj",
                "Dostpur",
                "Dudhi",
                "Dulhipur",
                "Ekdil",
                "Erich",
                "Etah",
                "Etah Indutrial Area",
                "Etawah",
                "Etmadpur",
                "Faizabad",
                "Faizganj",
                "Farah",
                "Faridnagar",
                "Faridpur, Bareilly District",
                "Fariha",
                "Farrukhabad",
                "Fatehabad",
                "Fatehganj Pashchimi",
                "Fatehganj Purvi",
                "Fatehgarh",
                "Fatehpur",
                "Fatehpur Chaurasi",
                "Fatehpur Sikri Fatehpur, Barabanki District",
                "Fazi Nagar",
                "Firozabad",
                "Firozabad UPSIDC",
                "Gabhana",
                "Gadhi",
                "Gagalhedi Must",
                "Gajraula",
                "Gangapur",
                "Gangiri",
                "Gangoh",
                "Ganj Dundwara",
                "Ganj Muradabad",
                "Ganwaria Tulsipur",
                "Garauri",
                "Garautha",
                "Garhi Pukhta",
                "Garhmukteshwar",
                "Gaura",
                "Gaura Barhaj",
                "Gaura Kala",
                "Gauri Bazar",
                "Gausganj",
                "Gawan",
                "Ghatampur",
                "Ghaziabad",
                "Ghazipur",
                "Ghiraur",
                "Ghorawal",
                "Ghosi",
                "Ghosia Bazar",
                "Ghughuli",
                "GIDA Gorakhpur",
                "Gird Baragaon",
                "Gohand",
                "Gokul",
                "Gola Bazar",
                "Gola Gokarannath",
                "Gonda",
                "Gopamau",
                "Gopi Ganj",
                "Gorakhpur",
                "Gosainganj",
                "Gosainganj, Lucknow District",
                "Got",
                "Govardhan",
                "Greater Noida",
                "Gulaothi",
                "Gulariya",
                "Gunnaur",
                "Gursahaiganj",
                "Gursarai",
                "Gyanpur",
                "Hafiz Ganj",
                "Haidergarh",
                "Haldaur",
                "Hallaur",
                "Hamirpur",
                "Handia",
                "Hapur",
                "Haqiqatpur",
                "Hardoi",
                "Harduaganj",
                "Hargaon",
                "Hariharpur",
                "Hariyawan",
                "Harraiya",
                "Hasanpur",
                "Hasayan",
                "Hastinapur",
                "Hata",
                "Hathgram",
                "Hathras",
                "Hyderabad",
                "Ibrahimpur",
                "Iglas",
                "Ikauna",
                "Iltifatganj Bazar",
                "Indian Tehephone Industry Mankapur",
                "Indian Telephone Industry",
                "Islamnagar",
                "Itaunja",
                "Itwa",
                "Jafarabad",
                "Jagner",
                "Jahanabad",
                "Jahangirabad",
                "Jahangirpur",
                "Jais",
                "Jaithara",
                "Jalalabad",
                "Jalalabad, Bijnor District",
                "Jalalabad, Muzaffarnagar District",
                "Jalali",
                "Jalalpur",
                "Jalaun",
                "Jalesar",
                "Jamshila",
                "Jamuhan",
                "Jangipur",
                "Jansath",
                "Jarwal",
                "Jasra",
                "Jasrana",
                "Jaswantnagar",
                "Jatari",
                "Jaunpur",
                "Jewar",
                "Jhalu",
                "Jhansi",
                "Jhinjhak",
                "Jhinjhana",
                "Jiyanpur",
                "Joya",
                "Jugauli",
                "Jyoti Khuria",
                "Kabrai",
                "Kachhauna Patseni",
                "Kachhla",
                "Kachhwa",
                "Kachnar",
                "Kadaura",
                "Kadipur",
                "Kailashpur",
                "Kaimganj",
                "Kairana",
                "Kakari",
                "Kakod",
                "Kakori",
                "Kakrala",
                "Kalinagar",
                "Kalpi",
                "Kamalganj",
                "Kampil",
                "Kanaudia Chamical & Industries Ltd",
                "Kandharpur",
                "Kandhla",
                "Kannauj",
                "Kanpur",
                "Kanth",
                "Kanth, Shahjahanpur District",
                "Kaptanganj",
                "Karari",
                "Karhal",
                "Karnawal",
                "Karwi",
                "Kasba Khanpur",
                "Kasganj",
                "Kasiya",
                "Kataka",
                "Kataria",
                "Katghar Lalganj",
                "Kathaura",
                "Kathera",
                "Katra",
                "Katra Medniganj",
                "Katra, Gonda District",
                "Kaulakha",
                "Kauria ganj",
                "Kemri",
                "Kerakat",
                "Kewalpur",
                "Khadda",
                "Khaga",
                "Khailar",
                "Khair",
                "Khairabad",
                "Khairabad, Mau District",
                "Khalilabad",
                "Khamaria",
                "Khandauli",
                "Khanpur",
                "Kharela",
                "Khargupur",
                "Khariya",
                "Kharkhoda",
                "Khatauli",
                "Khekada",
                "Kheragarh",
                "Kheri",
                "Kheta Sarai",
                "Khudaganj",
                "Khurja",
                "Khutar",
                "Kiraoli",
                "Kiratpur",
                "Kishni",
                "Kishunpur",
                "Kithaur",
                "Koeripur",
                "Konch",
                "Kopaganj",
                "Kora Jahanabad",
                "Koraon",
                "Korwa",
                "Kosi Kalan",
                "Kota",
                "Kota, Sonbhadra District",
                "Kotra",
                "Kotwa",
                "Kotwali",
                "Kulpahar",
                "Kunda",
                "Kundarki",
                "Kunwargaon",
                "Kuraoli",
                "Kurara",
                "Kursath",
                "Kursath, Hardoi District",
                "Kursi Road Industrial Area",
                "Kurthi Jafarpur",
                "Kushinagar",
                "Kusmara",
                "Laharpur",
                "Lakhimpur",
                "Lakhna",
                "Lal Gopalganj Nindaura",
                "Lalganj",
                "Lalitpur",
                "Lar",
                "Lawar",
                "Leather Park Banthar",
                "Ledwa Mahua",
                "Loni",
                "Lucknow",
                "Machhlishahr",
                "Madhoganj",
                "Madhogarh",
                "Madiya",
                "Maghar",
                "Mahaban",
                "Maharajganj",
                "Mahimapur",
                "Mahmudabad",
                "Mahoba",
                "Maholi",
                "Mahona",
                "Mahrajganj",
                "Mahrajganj, Azamgarh District",
                "Mahroni",
                "Mahul Khas",
                "Maigal Ganj",
                "Mailani",
                "Maina Maujpur",
                "Mainpuri",
                "Majhauliraj",
                "Makhanpur",
                "Malhipur",
                "Malihabad",
                "Mallawan",
                "Mandawar",
                "Manikpur",
                "Manikpur Sarhat",
                "Maniyar",
                "Manjhanpur",
                "Mankapur",
                "Marehra",
                "Mariahu",
                "Maswasi",
                "Mataundh",
                "Mathura",
                "Mau Aima",
                "Maudaha",
                "Maunath Bhanjan",
                "Maurawan",
                "Mawana",
                "Meerut",
                "Mehdawal",
                "Mehnagar",
                "Mendu",
                "Middha",
                "Milak",
                "Miranpur",
                "Mirganj",
                "Mirzapur cum Vindhyachal",
                "Misrikh Cum Neemsar",
                "Modinagar",
                "Mogra Badshahpur",
                "Mohammadabad",
                "Mohammadabad, Farrukhabad District",
                "Mohammadi",
                "Mohan",
                "Mohanpur",
                "Mohiuddinpur",
                "Moradabad",
                "Moth",
                "Mubarakpur",
                "Mughalsarai",
                "Muhammadabad",
                "Mundera Bazar",
                "Mundia",
                "Muradnagar",
                "Mursan",
                "Musafirkhana",
                "Muzaffarnagar",
                "Nadigaon",
                "Nagina",
                "Nagram",
                "Nai Bazar",
                "Naini Industrial Area",
                "Najibabad",
                "Nakur",
                "Nanauta",
                "Nandgaon",
                "Nanpara",
                "Naraini",
                "Narauli",
                "Naraura",
                "Naugarh",
                "Naugawan Sadat",
                "Nautanwa",
                "Nawabganj",
                "Nawabganj, Bareilly District",
                "Nawabganj, Unnao District",
                "Nehtaur",
                "Nichlaul",
                "Nidhauli Kalan",
                "Nihal Garh Chak Jangla",
                "Nivi",
                "Niwari",
                "Nizamabad",
                "Noida",
                "Noorpur",
                "Nyoria Husainpur",
                "Nyotini",
                "Obra",
                "Oel Dhakwa",
                "Orai",
                "Orai Industrial Area",
                "Orai Jalaun District",
                "Oran",
                "Pachperwa",
                "Padarathpur",
                "Padrauna",
                "Pahar Ganj",
                "Pahasu",
                "Paintepur",
                "Pakbara",
                "Pali",
                "Pali, Hardoi District",
                "Palia Kalan",
                "Palpur",
                "Parasi",
                "Parichha",
                "Parikshitgarh",
                "Parsadepur",
                "Parsakhera Industrial Area",
                "Parsona",
                "Patadi",
                "Patala",
                "Patiyali",
                "Patti",
                "Pavi Sadakpur",
                "Phalauda",
                "Phaphund",
                "Phulpur",
                "Phulpur, Allahabad District",
                "Pihani",
                "Pilibhit",
                "Pilkhana",
                "Pilkhuwa",
                "Pinahat",
                "Pipalsana Chaudhari",
                "Pipara Dand",
                "Pipiganj",
                "Pipraich",
                "Piprayli Bujurg",
                "Pipri",
                "Powayan",
                "Pratapgarh City",
                "Pukhrayan",
                "Puranpur",
                "Purdilnagar",
                "Pure Tiwari",
                "Purquazi",
                "Purwa",
                "Qasimpur Power House Colony",
                "Rabupura",
                "Radhakund",
                "Rae Bareli",
                "Raja ka Rampur",
                "Rajapur",
                "Ram Nagar Industrial Area",
                "Ramdaspur Urf Nagal",
                "Ramkola",
                "Ramnagar",
                "Rampur",
                "Rampur Bhawanipur",
                "Rampur Karkhana",
                "Rampur Maniharan",
                "Rampura",
                "Ranipur",
                "Raniyan",
                "Rasra",
                "Rasulabad",
                "Rasulabad Unnao District",
                "Ratanpura",
                "Rath",
                "Rati Ka Nagla Industrial Area",
                "Raya",
                "Renukoot",
                "Reoti",
                "Richha",
                "Risia Bazar",
                "Rithora",
                "Robertsganj",
                "Rori",
                "Rudauli",
                "Rudayan",
                "Rudrapur",
                "Runkata",
                "Rura",
                "Rustamnagar Sahaspur",
                "Sadabad",
                "Sadat",
                "Sadatmasaura",
                "Sadruddin Nagar",
                "Safipur",
                "Sahanpur",
                "Saharanpur",
                "Sahaspur",
                "Sahaswan",
                "Sahatwar",
                "Sahawar",
                "Sahjanwan",
                "Sahpau",
                "Saidpur",
                "Saidpur Khajuria",
                "Saidpur, Budaun District",
                "Sainthal",
                "Saiyad Raja",
                "Sakaldiha",
                "Sakhanu",
                "Sakit",
                "Salarpur",
                "Salempur",
                "Salon",
                "Sambhal",
                "Samdhan",
                "Samthar",
                "Sandi",
                "Sandila",
                "Sandilla",
                "Sapur Banger",
                "Sarai Abdulmalik",
                "Sarai Aquil",
                "Sarai Lahur",
                "Sarai mir",
                "Sarai Mohana",
                "Saraon",
                "Sardhana",
                "Sarila",
                "Sarnath",
                "Sarsawan",
                "Sarsual",
                "Sasni",
                "Satiyava",
                "Satrikh",
                "Saunkh",
                "Saurikh",
                "Seohara",
                "Sewalkhas",
                "Sewarhi",
                "Shahabad",
                "Shahabad, Rampur District",
                "Shahganj",
                "Shahi",
                "Shahjahanpur",
                "Shahpur",
                "Shamli",
                "Shamsabad",
                "Shamsabad, Agra District",
                "Shankargarh",
                "Shaoron",
                "Shergarh",
                "Sherkot",
                "Shikarpur",
                "Shikohabad",
                "Shishgarh",
                "Shivli",
                "Shivrajpur",
                "Shohratgarh",
                "Siana",
                "Siddhaur",
                "Sidhauli",
                "Sidhpura",
                "Sikandarabad Industrial Area",
                "Sikanderpur",
                "Sikanderpur, Kannauj District",
                "Sikandra",
                "Sikandra Rao",
                "Sikandrabad",
                "Sikindra",
                "Sikri Kalan",
                "Singahi Bhiraura",
                "Sirathu",
                "Sirauli",
                "Sirsa",
                "Sirsaganj",
                "Sirsi",
                "Sisauli",
                "Siswa Bazar",
                "Sitapur",
                "Soron",
                "Suar",
                "Subeha",
                "Sultanpur",
                "Sumerpur",
                "Suriyawan",
                "Suthana Barsola",
                "Suzabad",
                "Talbehat",
                "Talgram",
                "Tambaur Cum Ahmadabad",
                "Tanda",
                "Tanda, Rampur District",
                "Tatarpur Lallu",
                "Thakurdwara",
                "Thana Bhawan",
                "Thiriya Nizamat Khan",
                "Tikait Nagar",
                "Tikri",
                "Tikuniya",
                "Tilhar",
                "Tilthi",
                "Tindwari",
                "Tirwaganj",
                "Titron",
                "Tondi Fatehpur",
                "Tronica City",
                "Tulsipur",
                "Tundla",
                "Tundla Kham",
                "Tundla Rly Colony",
                "Ugu",
                "Ujhani",
                "Ujhari",
                "Umarha",
                "Umri",
                "Umri Kalan",
                "Un",
                "Unchahar",
                "Unnao",
                "Usawan",
                "Usehat",
                "Uska Bazar",
                "Utraula",
                "Varanasi",
                "Vijaigarh",
                "Vrindavan",
                "Walidpur",
                "Warhapur",
                "Wazirganj",
                "Zaidpur",
                "Zamania",
            ],
        },
        {
            name: "Uttarakhand",
            code: "UK",
            cities: [
                "Almora",
                "Auli",
                "Badrinath",
                "Bageshwar",
                "Bahadarabad",
                "Banbasa",
                "Bandia",
                "Bandiya",
                "Barkot",
                "Bazpur",
                "Begumpur",
                "Berinag",
                "Bhagwanpur",
                "Bhimtaal",
                "Bhowali",
                "Chakrata",
                "Chamba",
                "Chamoli",
                "Champawat",
                "Chaukori",
                "Corbett",
                "Dehradun",
                "Devaprayag",
                "Devaprayag, Garhwal District",
                "Dhanaulti",
                "Dharchula",
                "Dharchula Dehat",
                "Didihat",
                "Dineshpur",
                "Dogadda",
                "Doiwala",
                "Dwarahat",
                "Gadarpur",
                "Gangolihat",
                "Gangotri",
                "Gochar",
                "Gopeshwar",
                "Haldwani",
                "Haridwar",
                "Herbertpur",
                "Jaspur",
                "Jhabrera",
                "Joshimath",
                "Kachnal Gosain",
                "Kaladhungi",
                "Karnaprayag",
                "Kashipur",
                "Kathgodam",
                "Kausani",
                "Kela Khera",
                "Khatima",
                "Kichha",
                "Kirtinagar",
                "Kotdwara",
                "Laksar",
                "Lalkuan",
                "Landaur",
                "Landhaura",
                "Lansdowne",
                "Lohaghat",
                "Mahua Dabra Haripura",
                "Mahua Kheraganj",
                "Manglaur",
                "Mehwar Kalan",
                "Mohanpur Mohammadpur",
                "Mukteshwar",
                "Mussoorie",
                "Nagala Imarti",
                "Nagla",
                "Nainital",
                "Nandprayag",
                "Narendranagar",
                "Natthuwa Wala",
                "New Tehri",
                "Pantnagar",
                "Pauri",
                "Piran Kaliyar",
                "Pithoragarh",
                "Pratitnagar",
                "Raipur",
                "Ramnagar",
                "Ranikhet",
                "Rishikesh",
                "Roorkee",
                "Rudraprayag",
                "Rudrapur",
                "Saidpura",
                "Sara Industrial Estate",
                "Selaqui",
                "Shaktigarh",
                "SIDCUL Haridwar",
                "SIDCUL Kotadwara",
                "Sitarganj",
                "Srinagar",
                "Sultanpur",
                "Tanakpur",
                "Tehri",
                "Uttarkashi",
                "Vikasnagar",
            ],
        },
        {
            name: "West Bengal",
            code: "WB",
            cities: [
                "Adra",
                "Ahmadpur",
                "Aiho",
                "Ajodhyanagar",
                "Alipukur",
                "Alipurduar",
                "Alipurduar Rly Jnc",
                "Amarshi Kasba",
                "Ambhua",
                "Amlagora",
                "Amlajora",
                "Amta",
                "Amtala",
                "Anantabati",
                "Andal",
                "Andul",
                "Ankurhati",
                "Anup Nagar",
                "Arambag",
                "Argari",
                "Arjunpur",
                "Arra",
                "Asansol",
                "Ashadtalya",
                "Aurangabad",
                "Badamtam Tea Garden",
                "Badkulla",
                "Baduria",
                "Bagnan",
                "Bagula",
                "Bahirgram",
                "Bahula",
                "Baidyabati",
                "Bakreshwar Thermal Power Township",
                "Baksa",
                "Balarampota",
                "Balarampur",
                "Balarampur, South Twenty Four Parganas District",
                "Balichak",
                "Balihati",
                "Bally",
                "Baluhati",
                "Balurghat",
                "Bamangram",
                "Bamanpukur",
                "Bamna",
                "Bamunari",
                "Ban Harishpur",
                "Banarhat Tea Garden",
                "Bandhail",
                "Bandipur",
                "Bandoan",
                "Baneshwarpur",
                "Baneshwarpur Haora District",
                "Baneswar",
                "Bangalpur",
                "Bangaon",
                "Baniban",
                "Baniban Jagadishpur",
                "Bankra",
                "Bankra North Twenty Four Parganas District",
                "Bankul",
                "Bankura",
                "Bansberia",
                "Banshra",
                "Banupur",
                "Bara",
                "Bara Jumla",
                "Bara Suzapur",
                "Barabazar",
                "Barasat",
                "Barda",
                "Bargachhia",
                "Bargachhia Hugli District",
                "Barijhati",
                "Barijpur",
                "Barjora",
                "Barkalikapur",
                "Barrackpur",
                "Barrackpur Cantonment",
                "Barua Gopalpur",
                "Baruipara",
                "Baruipur",
                "Barunda",
                "Basantapur",
                "Basanti",
                "Basantia",
                "Basirhat",
                "Baska",
                "Basudebpur",
                "Basudebpur Purba Medinipur District",
                "Batika",
                "Batul",
                "Bayarsing",
                "Begampur",
                "Begun Kodar",
                "Beldanga",
                "Beldubi",
                "Beliatore",
                "Belumilki",
                "Benudia",
                "Berhampore",
                "Betpuli",
                "Bhabki",
                "Bhadreswar",
                "Bhagabatipur",
                "Bhandar Gachha",
                "Bhandardaha",
                "Bhangar Raghunathpur",
                "Bhangri Pratham Khanda",
                "Bhasa",
                "Bhasaipaikar",
                "Bhatpara",
                "Bhimram",
                "Bholar Dabri",
                "Bidhan Nagar",
                "Bikihakola",
                "Bilandapur",
                "Bilpahari",
                "Bipra Noapara",
                "Bira",
                "Birlapur",
                "Birnagar",
                "Birodhi",
                "Birpara",
                "Birpara, Jalpaiguri District",
                "Bishnupur",
                "Bishnupur Birbhum District",
                "Bishnupur Industrial Growth Centre",
                "Bishnupur, South Twenty Four Parganas District",
                "Bolpur",
                "Bora Gagangohalia",
                "Borai",
                "Bowali",
                "Brindabanpur",
                "Budge Budge",
                "Buita",
                "Burdwan",
                "Cart Road",
                "Chachanda",
                "Chak Alampur",
                "Chak Bankola",
                "Chak Baria",
                "Chak Bhrigu",
                "Chak Enayetnagar",
                "Chak Kanthalia",
                "Chak Kashipur",
                "Chakapara",
                "Chakdaha",
                "Chakiabhita",
                "Chakmeghoan",
                "Chalsa Mahabari",
                "Champahati",
                "Champdani",
                "Chamrail",
                "Chanchal",
                "Chandannagar",
                "Chandapur Champagachhi",
                "Chanddandaha",
                "Chandipur",
                "Chandipur Haora District",
                "Chandpala Anantapathpur",
                "Chandpur",
                "Chandpur South Twenty Four Parganas District",
                "Chandrakona",
                "Chandrapur",
                "Chapari",
                "Chapra",
                "Chaspara",
                "Chaulia",
                "Chechakhata",
                "Chekya",
                "Chhekati",
                "Chhora",
                "Chhota Laukuthi",
                "Chhota Suzapur",
                "Chikanpara",
                "Chikrand",
                "Chinchuria",
                "Chittaranjan",
                "Chong Ghurali",
                "Chongtong Tea Garden",
                "Chopra",
                "Contai",
                "Dafahat",
                "Dakhin Rampur",
                "Dakshin Baguan",
                "Dakshin Chatra",
                "Dakshin Jhapardaha",
                "Dakshin Odlabari",
                "Dakshin Rajyadharpur",
                "Dakshin Raypur",
                "Dakshin Santoshpur",
                "Dalkhola",
                "Dalurband",
                "Danga",
                "Dankuni",
                "Darappur",
                "Darjeeling",
                "Daulatpur",
                "Deara",
                "Debipur",
                "Deora",
                "Deulgram",
                "Deuli",
                "Deulia",
                "Dhakuria",
                "Dhaliabari",
                "Dhamua",
                "Dhandadihi",
                "Dhania",
                "Dhanyakuria",
                "Dharmapur",
                "Dhatrigram",
                "Dhola",
                "Dhuilya",
                "Dhulasimla",
                "Dhulian",
                "Dhunki",
                "Dhupguri",
                "Dhusaripara",
                "Diamond Harbour",
                "Digha",
                "Dighirpar",
                "Dignala",
                "Dihimandalghat",
                "Dinga Khola",
                "Dinhata",
                "Dogachhia",
                "Dogachhia Barddhaman District",
                "Domjur",
                "Dubra",
                "Dubrajpur",
                "Dudhkalmi",
                "Durgapur",
                "Durllabhganj",
                "Egra",
                "Ekabbarpur",
                "Eksara",
                "Erashal",
                "Falakata",
                "Falta Industrial Growth Centre",
                "Farakka Barrage Township",
                "Farakka PTS Township",
                "Fatehpur",
                "Fatellapur",
                "Fatepur",
                "Gabberia",
                "Gairkata",
                "Gangadharpur",
                "Gangarampur",
                "Gangi",
                "Gangnapur",
                "Gangni",
                "Garalgachha",
                "Garbeta",
                "Garh Kamalpur",
                "Garshyamnagar",
                "Garulia",
                "Gaur Daha",
                "Geni",
                "Ghatal",
                "Ghola Noapara",
                "Ghoraberia",
                "Ghutgarya",
                "Ging Tea Garden",
                "Giria",
                "Goasafat",
                "Gobardanga",
                "Gobindapur",
                "Gopalpur",
                "Guskara",
                "Habra",
                "Haldia",
                "Haldibari",
                "Halisahar",
                "Halyan",
                "Hanskunda",
                "Hanspukuria",
                "Haora",
                "Harharia Chak",
                "Harinadibhastsala",
                "Harindanga",
                "Haringhata Farm",
                "Haripur",
                "Harirampur",
                "Harishpur",
                "Hasimnagar",
                "Hatgachha",
                "Hatsimla",
                "Hijuli",
                "Hincha Gerya",
                "Hindusthan Cables Town",
                "Hingalganj",
                "Hirapur",
                "Hugli-Chinsurah",
                "Hutmura",
                "Ichhapur Defence Estate",
                "Ichhlampur",
                "Ilambazar",
                "Islampur",
                "Itahar",
                "Itinda",
                "Jadupur",
                "Jafarpur",
                "Jagadanandapur",
                "Jagadishpur",
                "Jagatballavpur",
                "Jagatnagar",
                "Jagijhora Barabak",
                "Jagtaj",
                "Jala Kendua",
                "Jallabad",
                "Jalpaiguri",
                "Jaluidanga",
                "Jamuria",
                "Janai",
                "Jangalpara",
                "Jangalpara, Hugli District",
                "Jangipur",
                "Jateshwar",
                "Jaygaon",
                "Jaykrishnapur",
                "Jaynagar Mazilpur",
                "Jaypur",
                "Jemari",
                "Jetia",
                "Jhalda",
                "Jhanti Pahari",
                "Jhargram",
                "Jhorhat",
                "Jiaganj Azimganj",
                "Jirat",
                "Joka",
                "Joypul",
                "Jujarsaha",
                "Kachu Pukur",
                "Kaijuri",
                "Kajora",
                "Kakdihi",
                "Kakramari",
                "Kalara",
                "Kalaria",
                "Kalas North",
                "Kaliaganj",
                "Kalikapota",
                "Kalikapur",
                "Kalimpong",
                "Kalipur",
                "Kalipur Barddhaman District",
                "Kalna",
                "Kalyani",
                "Kalyanpur",
                "Kamalapur",
                "Kamat Phulbari",
                "Kanaipur",
                "Kanaipur Haora District",
                "Kanchrapara",
                "Kandi",
                "Kanganbaria",
                "Kanki",
                "Kankuria",
                "Kanpur",
                "Kantaberia",
                "Kantlia",
                "Kanyanagar",
                "Kapashanria",
                "Karari Chandpur",
                "Karia",
                "Karidhya",
                "Karimpur",
                "Kashimnagar",
                "Katwa",
                "Kaugachhi",
                "Kenda",
                "Kendra Khottamdi",
                "Kendua",
                "Kesabpur",
                "Khajutti",
                "Khalia",
                "Khalor",
                "Khandra",
                "Khanpur",
                "Khantora",
                "Kharagpur",
                "Kharar",
                "Khardaha",
                "Khardaha Haora District",
                "Kharibari",
                "Kharsarai",
                "Khatra",
                "Khidirpur",
                "Khidirpur, Murshidabad District",
                "Khorddabamonia",
                "Koch Bihar",
                "Kodalia",
                "Kokapur",
                "Kolaghat",
                "Kolkata",
                "Komarhat",
                "Konardihi",
                "Konnagar",
                "Kotbar",
                "Kotulpur",
                "Koyra",
                "Kriparampur",
                "Krishna Sali",
                "Krishnanagar",
                "Krishnapur",
                "Krishnapur Maldah District",
                "Kshidirpur",
                "Kshirpai",
                "Kulia",
                "Kulihanda",
                "Kulitapara",
                "Kulti",
                "Kurseong",
                "Labhpur",
                "Lagda",
                "Lalpur",
                "Lapara",
                "Laskarpara",
                "Lataguri",
                "Madhyamgram",
                "Madna",
                "Mahadeb Nagar",
                "Mahal",
                "Mahiari",
                "Mahira",
                "Mahishrekha",
                "Mainaguri",
                "Makardaha",
                "Makhal Tala",
                "Malbazar",
                "Malda",
                "Mamrejpur",
                "Manbazar",
                "Mandarbani",
                "Mangalbari",
                "Mangarjung Tea Garden",
                "Manikpur",
                "Manirampur",
                "Mansinhapur",
                "Manushpur",
                "Masat",
                "Masat South Twenty Four Parganas District",
                "Maslandapur",
                "Mathabhanga",
                "Matialihat",
                "Matiari",
                "Matla",
                "Medinipur",
                "Mejia Thermal Power Township",
                "Mekliganj",
                "Memari",
                "Milki",
                "Minakhan",
                "Mira",
                "Mirdhanga",
                "Mirik",
                "Mirzapur",
                "Mohanpur",
                "Mugkalyan",
                "Muragachha",
                "Murarai",
                "Murshidabad",
                "Murulia",
                "Nababpur",
                "Nabadwip",
                "Nabaghanapur",
                "Nabagram",
                "Nabagram Colony",
                "Nabgram",
                "Nadabhanga",
                "Nagar Changrabandha",
                "Nagdaha",
                "Nahazari",
                "Naihati",
                "Nainan",
                "Naiti",
                "Nalahati",
                "Naldanga",
                "Nalpur",
                "Nandigram",
                "Naridana",
                "Nasaratpur",
                "Nasibpur",
                "Natibpur",
                "Naul",
                "Naupala",
                "Nawapara",
                "Nayabahadurpur",
                "Nebadhai Duttapukur",
                "New Barrackpur",
                "New Town",
                "Nibra",
                "Nischintapur",
                "Nischintapur Paschim Medinipur District",
                "Nokpul",
                "North Barrackpur",
                "Nrisinghapur",
                "Odlabari",
                "Pairagachha",
                "Palashban",
                "Palashi",
                "Panchghara",
                "Panchla",
                "Panchpara",
                "Pandua",
                "Paniara",
                "Panihati",
                "Panuria",
                "Par Patiram",
                "Para",
                "Parangarpar",
                "Paranpara",
                "Parashkol",
                "Parasia",
                "Parota",
                "Paschim Bainan",
                "Paschim Gazipur",
                "Paschim Jitpur",
                "Paschim Panchla",
                "Paschim Punropara",
                "Pashchim Khalna",
                "Patdaha",
                "Patharberia",
                "Patihal",
                "Patuli",
                "Patulia",
                "Phulia",
                "Poali",
                "Podara",
                "Prayagpur",
                "Pujali",
                "Purba Bishnupur",
                "Purbba Narayanpur",
                "Purbba Tajpur",
                "Puruliya",
                "Radhapur",
                "Raghudebbati",
                "Raghunathpur",
                "Raghunathpur, Puruliya District",
                "Raichak",
                "Raigachhi",
                "Raiganj",
                "Raipur",
                "Rajbalhat",
                "Rajnagar",
                "Rajpur Bazar",
                "Rajpur Sonarpur",
                "Ramakantapur",
                "Ramanathpur",
                "Ramchandrapur",
                "Rameswarpur",
                "Ramjibanpur",
                "Ramkrishnapur",
                "Ramnagar",
                "Rampurhat",
                "Ranaghat",
                "Rangabhita",
                "Raniganj",
                "Raninagar Industrial Growth Centre",
                "Raynagar",
                "Rishra",
                "Rongmook Ceder Tea",
                "Garden",
                "Ruiya",
                "Sadigachhi",
                "Sahapur",
                "Sahebganj",
                "Sahebpur",
                "Sainthia",
                "Salap",
                "Salar",
                "Samali",
                "Samudragarh",
                "Samuktola",
                "Sangrampur",
                "Sankarpur",
                "Sankrail",
                "Santaldih",
                "Santipur",
                "Santoshpur",
                "Sarenga",
                "Sarpi",
                "Sehara",
                "Serampore",
                "Serpur",
                "Shankara",
                "Shashati",
                "Shilda",
                "Shimulpur",
                "Shyamdhan",
                "Shyampur",
                "Sibnagar",
                "Siduli",
                "Silampur",
                "Siliguri",
                "Simhat",
                "Simla",
                "Simlapal",
                "Singtam Tea Garden",
                "Singur",
                "Sirakol",
                "Sirsha",
                "Sisha-Jumrha",
                "Sobhaganj",
                "Solgohalia",
                "Sonada Khasmahal",
                "Sonamukhi",
                "Sonatikiri",
                "Srimantapur",
                "Sripur",
                "Subarnapur",
                "Sukdal",
                "Sukhiapokhri",
                "Suri",
                "Taki",
                "Talbandha",
                "Taldi",
                "Tamluk",
                "Tarakeswar",
                "Tehatta",
                "Tehatta Nadia District",
                "Teleni Para",
                "Telipara Tea Garden",
                "Tentulkuli",
                "Tisa",
                "Titagarh",
                "Tufanganj",
                "Udang",
                "Ukhra",
                "Uluberia",
                "Uluberia Near Kolkata",
                "Usthi",
                "Uttar Bagdogra",
                "Uttar Bishnupur",
                "Uttar Jhapardaha",
                "Uttar Kamakhyaguri",
                "Uttar Kusum",
                "Uttar Latabari",
                "Uttar Madarihat",
                "Uttar Mahammadpur",
                "Uttar Pirpur",
                "Uttar Raypur",
                "Uttar Satali",
                "Uttarpara Kotrung",
                "WBIIDC Growth Centre Uluberia",
            ],
        },
    ],
};
export const allCities = indiaCities.states.flatMap((state) => state.cities);

export const Fields = [
    [
        {
            type: "pills",
            name: "name",
            isMultiSelect: true,
            label: "What kind of artist are you?",
            options: [
                { label: "Singer", id: "1" },
                { label: "Dancer", id: "2" },
                { label: "Magician", id: "3" },

                { label: "Musician", id: "5" },
                { label: "DJ", id: "6" },
                { label: "Dance Group", id: "7" },
                { label: "Rapper", id: "8" },
                { label: "Beat Boxer", id: "9" },
                { label: "Video Editor", id: "10" },

                { label: "Photographer", id: "12" },
            ],
        },
    ],
    [
        {
            type: "pills",
            name: "singerGenre",
            isMultiSelect: true,
            label: "Tell us about your singing genre",
            options: [
                { key: "bollywood", label: "Bollywood" },
                { key: "pop", label: "Pop" },
                { key: "western", label: "Western" },
                { key: "bhajan", label: "Bhajan" },
                { key: "sufi", label: "Sufi" },
                { key: "jazz", label: "Jazz" },
                { key: "hip_hop", label: "Hip-Hop" },
                { key: "rap", label: "Rap" },
                { key: "ghazal", label: "Ghazal" },
                { key: "punjabi", label: "Punjabi" },
                { key: "classical", label: "Classical" },
                { key: "folk", label: "Folk" },
                { key: "rock", label: "Rock" },
                { key: "devotional", label: "Devotional" },
                { key: "qawwali", label: "Qawwali" },
                { key: "tamil", label: "Tamil" },
                { key: "telugu", label: "Telugu" },
                { key: "garba", label: "Garba" }
            ]
        },
        {
            type: "pills",
            name: "dancerGenre",
            isMultiSelect: true,
            label: "Tell us about your dancing genre",
            options: [

                { key: "bollywood", label: "Bollywood" },
                { key: "folk", label: "Folk" },
                { key: "hip_hop", label: "Hip Hop" },
                { key: "salsa", label: "Salsa" },
                { key: "wedding", label: "Wedding" },
                { key: "belly_dancer", label: "Belly Dancer" },
                { key: "freestyle", label: "Freestyle" },
                { key: "garba", label: "Garba" },
                { key: "kathak", label: "Kathak" },
                { key: "classical", label: "Classical" },
                { key: "bharatnatyam", label: "Bharatnatyam" },
                { key: "choreographer", label: "Choreographer" }


            ]
        },
        {
            type: "pills",
            name: "dancegroupGenre",
            isMultiSelect: true,
            label: "Tell us about your dancing genre",
            options: [
                { key: "bollywood", label: "bollywood" },
                { key: "folk", label: "folk" },
                { key: "hip_hop", label: "hip hop" },
                { key: "salsa", label: "salsa" },
                { key: "wedding", label: "wedding" },
                { key: "belly_dancer", label: "belly dancer" },
                { key: "freestyle", label: "freestyle" },
                { key: "garba", label: "garba" },
                { key: "kathak", label: "kathak" },
                { key: "classical", label: "classical" },
                { key: "bharatnatyam", label: "bharatnatyam" },
                { key: "choreographer", label: "choreographer" },

            ]
        },
        {
            type: "pills",
            name: "magicianGenre",
            isMultiSelect: true,
            label: "Tell us about your magic style",
            options: [
                { key: "illusionist", label: "illusionist" },
                { key: "card_magician", label: "card magician" },
                { key: "street_magician", label: "street magician" },
                { key: "psychological", label: "psychological" },
                { key: "table_magician", label: "table magician" },

            ]
        },
        {
            type: "pills",
            name: "vedioeditorGenre",
            isMultiSelect: true,
            label: "Tell us about your Video editing genre",
            options: [
                { key: "film", label: "film" },
                { key: "documentary", label: "documentary" },
                { key: "music_video", label: "music video" },
                { key: "commercial_advertisement", label: "commercial & advertisement" },
                { key: "corporate", label: "corporate" },
                { key: "wedding", label: "wedding" },
                { key: "vlogging", label: "vlogging" },
                { key: "social_media", label: "social media" },
                { key: "sports", label: "sports" },
                { key: "gaming_esports", label: "gaming & esports" },
                { key: "motion_graphics", label: "motion graphics" },
                { key: "animation", label: "animation" },

            ]
        },
        {
            type: "pills",
            name: "instrumentalistGenre",
            isMultiSelect: true,
            label: "What type of instruments do you play?",
            options: [
                { label: "guitar", id: "1", key: "guitar" },
                { label: "piano", id: "2", key: "piano" },
                { label: "violin", id: "3", key: "violin" },
                { label: "drums", id: "4", key: "drums" },
                { label: "flute", id: "5", key: "flute" },

            ]
        },
        {
            type: "pills",
            name: "musicianGenre",
            isMultiSelect: true,
            label: "What kind of music do you create?",
            options: [
                { key: "bollywood", label: "bollywood" },
                { key: "pop", label: "pop" },
                { key: "western", label: "western" },
                { key: "bhajan", label: "bhajan" },
                { key: "sufi", label: "sufi" },
                { key: "jazz", label: "jazz" },
                { key: "hip_hop", label: "hip-hop" },
                { key: "rap", label: "rap" },
                { key: "ghazal", label: "ghazal" },
                { key: "punjabi", label: "punjabi" },
                { key: "classical", label: "classical" },
                { key: "folk", label: "folk" },
                { key: "rock", label: "rock" },
                { key: "devotional", label: "devotional" },
                { key: "qawwali", label: "qawwali" },
                { key: "tamil", label: "tamil" },
                { key: "telugu", label: "telugu" },
                { key: "garba", label: "garba" },

            ]
        },
        {
            type: "pills",
            name: "djGenre",
            isMultiSelect: true,
            label: "What type of djing do you do?",
            options: [
                { key: "techno", label: "techno" },
                { key: "dubstep", label: "dubstep" },
                { key: "edm", label: "edm" },
                { key: "bollywood_dj", label: "bollywood dj" },
                { key: "rock", label: "rock" },
                { key: "punjabi", label: "punjabi" },
                { key: "indie", label: "indie" },
                { key: "tamil", label: "tamil" },
                { key: "telugu", label: "telugu" },
                { key: "kannada", label: "kannada" },
                { key: "malayalam", label: "malayalam" },

            ]
        },
        {
            type: "pills",
            name: "rapperGenre",
            isMultiSelect: true,
            label: "What kind of rap do you perform?",
            options: [
                { label: "rapper", id: "1", key: "rapper" },


            ]
        },
        {
            type: "pills",
            name: "beatboxGenre",
            isMultiSelect: true,
            label: "What style of Beatboxing do you do?",
            options: [
                { key: "beat_boxer", label: "beat boxer" },

            ]
        },
        {
            type: "pills",
            name: "musicbandGenre",
            isMultiSelect: true,
            label: "What style of beatboxing do you do?",
            options: [
                { key: "bollywood", label: "bollywood" },
                { key: "pop", label: "pop" },
                { key: "western", label: "western" },
                { key: "bhajan", label: "bhajan" },
                { key: "sufi", label: "sufi" },
                { key: "jazz", label: "jazz" },
                { key: "hip_hop", label: "hip-hop" },
                { key: "rap", label: "rap" },
                { key: "ghazal", label: "ghazal" },
                { key: "punjabi", label: "punjabi" },
                { key: "classical", label: "classical" },
                { key: "folk", label: "folk" },
                { key: "rock", label: "rock" },
                { key: "devotional", label: "devotional" },
                { key: "qawwali", label: "qawwali" },
                { key: "tamil", label: "tamil" },
                { key: "telugu", label: "telugu" },
                { key: "garba", label: "garba" }

            ]
        },
        {
            type: "pills",
            name: "photographyGenre",
            isMultiSelect: true,
            label: "What style of Photography do you do?",
            options: [
                { key: "portrait", label: "portrait" },
                { key: "wedding", label: "wedding" },
                { key: "fashion_photographer", label: "fashion photographer" },
                { key: "landscape", label: "landscape" },
                { key: "wildlife", label: "wildlife" },
                { key: "sports", label: "sports" },
                { key: "product", label: "product" },
                { key: "food", label: "food" },
                { key: "street", label: "street" },
                { key: "documentary", label: "documentary" },

            ]
        }

    ],
    [
        { type: "text", name: "address", label: "Address", isMultiLine: true },
        {
            type: "pills",
            name: "experience_years",
            isMultiSelect: false,
            label: "How many years of experience do you have in your art?",
            options: [
                { label: "Beginner 😇", id: "0" },
                { label: "1-3", id: "1" },
                { label: "3-5", id: "2" },
                { label: "5-10", id: "3" },
                { label: "10-20", id: "4" },

            ],
        }
    ],
    [
        {
            type: "pills",
            name: "things_i_enjoy",
            isMultiSelect: true,
            label: "What best describes your artistic style?",
            options: [
                { label: "🎤 Vocal & Singing", id: "1" },
                { label: "💃 Expressive Dance", id: "2" },
                { label: "🎭 Theatrical Performance", id: "3" },
                { label: "🎨 Visual Arts & Painting", id: "4" },
                { label: "🎶 Instrumental & Music", id: "5" },
                { label: "🪄 Magic & Illusions", id: "6" },
                { label: "🤹 Acrobatics & Stunts", id: "7" },
                { label: "📷 Photography & Cinematics", id: "8" },
                { label: "✍️ Creative Writing & Poetry", id: "9" },
            ],
        },
    ],
    [
        {
            type: "pills",
            name: "where_do_love_performing",
            isMultiSelect: true,
            label: "Where do you love performing?",
            options: [
                { label: "🎭 Theaters & Stage Shows", id: "1" },
                { label: "🎤 Concerts & Live Music Events", id: "2" },
                { label: "🏟️ Festivals & Open-Air Venues", id: "3" },
                { label: "🎥 Online & Social Media", id: "4" },
                { label: "🏛️ Art Galleries & Exhibitions", id: "5" },
                { label: "🎪 Street & Public Spaces", id: "6" },
            ],
        },
    ],
    [
        {
            type: "pills",
            isMultiSelect: true,
            label: "Which audience size do you prefer ?",
            name: "crowd_size_preference",
            options: [
                { label: "Small, intimate crowd", value: "small", id: "1" },
                { label: "Medium-sized (100-500)", value: "medium", id: "2" },
                { label: "Large, high-energy audience (500+)", value: "large", id: "3" },

            ],
        },
    ],
    [
        {
            type: "textPillSelection",
            isMultiSelect: true,
            fullwidth: true,
            label: "Select cities in which you are available",
            name: "available_locations",
            options: allCities,
        },
    ],
    [
        { type: "text", placeholder: "Your Bio", label: "Write a Catchy Bio Here 😉", name: "about", isMultiLine: true },
    ],
    [
        { type: "photo", name: "photo", label: "Drop your profile picture here" },
        { type: "video", name: "videos", label: "Add your performances youtube video links here" },
    ],
];
